import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import DownwardArrow from "../../images/DownwardArrow.svg";
import SideArrow from "../../images/SideArrow.svg";
import axios from "axios";
import WebFont from "webfontloader";
import withStyles from "@mui/styles/withStyles";
import ColorPicker from "../ColorPicker";
import reactCSS from "reactcss";
import { useTranslation } from "react-i18next";
import "../../styles/components/RightPanel.scss";
import Switch from "@mui/material/Switch";
import ImageUpload from "../../images/ImageUpload.png";
import InfoIcon from "../../images/iconinfo.svg";
import { TextField, Tooltip, Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import AV from "../../images/EditorAnimation/AV.svg";
import LineHeight from "../../images/EditorAnimation/LineHeight.svg";
import {
  useDisplaycolorpicker,
  useDisplaycolorpickerBorder,
  useDisplaycolorpickerFontColor,
  useDisplaycolorpickerBgColor,
  useDisplaycolorpickerScrollColor,
  useDisplaycolorpickerTextBg,
  useColorpickerFontColorISI,
  useColorpickerTextBgColorISI,
  useScrollThumbcolorpicker,
  useScrollThumbBgColorPicker,
} from "./DisplaycolorPicker.js";
import { browseImages } from "../../services/apis";
import {
  getShapeSvgSourceKey,
  isShapeMatchingCanvasSize,
  isSvgShapeType,
  setSvgAttributeInSrc,
  toSvgHexColor,
} from "../../Uitls/shapeStrokeOverlay";
import {
  fontSizeItems,
  letterSpacingItems,
  lineHeightItems,
  borderStyles,
  bannerSizes,
} from "../../Uitls/RightPanelToolBarItems";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import GlobalSetting from "./GlobalSetting";
import Transform from "./Transform.js";
import ScrollBarArrow from "./ScrollBar.js";
import TextAndButton from "./ButtonSettings";
import ButtonAndShape from "./ButtonAndShape";
import ImageComp from "./ImageSettings";
import ImageBorder from "./ImageBorder";
import HitAreaModal from "./HitAreaModal";
import {
  buildHitAreaAnimationArray,
  getHitAreaKeyframesForAnimation,
  HIT_AREA_MODAL_TIMELINE_DURATION,
  isDefaultHitAreaUrlValue,
} from "./HitAreaModal/utils";
import ValueContext from "../../ContextAPi/appContext";
import { getRhsFontOptionCssStack } from "../../Uitls/CommonFroalaConfig";
import { getResolvedCustomFonts } from "../../services/customFontsApi";
import InfotabSection from "../../components/InfoTabSection";
import { toast } from "react-toastify";
import {
  getValidInput,
  sanitizeDecimalFieldValue,
  BORDER_DECIMAL_FIELDS,
  roundTo2Decimals,
  normalizeComponentStylesDecimals,
  shouldPreserveDecimalInput,
  isValidHttpUrl,
  checkURL
} from "../../Uitls/Util";
import {
  applyListFormat,
  convertHex,
  convertRgbaStrToObj,
  fontStyleToggle,
  handleCompAspectRatio,
  rgbaStringToObject,
  updateAlignment,
  updateComponentInArray,
} from "../../Uitls/EditorUtil.js";
import { footnotes } from "../../Uitls/ComponentType.js";
// function TabPanel(props) {
//   const { children, value, index, ...other } = props;

//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       key={index}
//       id={`full-width-tabpanel-${index}`}
//       aria-labelledby={`full-width-tab-${index}`}
//       {...other}
//     >
//       {value === index && <Box p={1}>{children}</Box>}
//     </div>
//   );
// }
// TabPanel.propTypes = {
//   children: PropTypes.node,
//   index: PropTypes.any.isRequired,
//   value: PropTypes.any.isRequired,
// };

const RightPanel = ({
  triggerUndoCapture,
  isAspectRatioLocked,
  setIsAspectRatioLocked,
  bannerId,
  isInfoPanel,
  myCanvasRef,
  dimensionsData,
  selectedComponent,
  setSelectedComponent,
  layerCompData,
  setLayerCompData,
  setCanvasStyleDraft,
  animationObject,
  setAnimationObject,
  layerIndex,
  createFroalaInstance,
  froalaFontAlignments,
  froalaNumberList,
  froalaFontStyles,
  froalaIndex,
  imageOnCanvas,
  layerId,
  canvasDimension,
  setCanvasDimension,
  showAssettype,
  checkedAspect,
  expanded,
  handleChange,
  toggleScrollbar,
  setCheckedScroll,
  checkedScroll,
  showBannertype,
  toggleAnimatedBanner,
  getEditSaveAssets,
  persistBannerCanvas,
  setShowBannerName,
  setundoFlag,
  setCanvasUpdated,
  bgColorCanvas,
  setBgColorCanvas,
  canvasBgChange,
  setCanvasBgChange,
  setOpenTimelinePopup,
  scrollBarExpand,
  genericInfo,
  setGenericInfo,
  playPause,
  updateSelctedFontstyle,
  selectedFontId,
  setSelectedFontId,
  damsID,
  setMLRstatus,
  MLRstatus,
  multiSelectedComps,
  setUpdatedValue,
  updatedValue,
  setExpanded,
  isCustomScroll,
  seconds,
}) => {
  const rightPanelRef = useRef(null);
  const [googleWebFonts, setGoogleWebFonts] = useState([]);
  const [fontWeightItems, setFontWeightItems] = useState([]);

  const appData = useContext(ValueContext);
  const savedCustomFontList = appData?.savedCustomFontList ?? [];
  const getFontOptionCssStack = (fontItem) =>
    getRhsFontOptionCssStack(fontItem, savedCustomFontList);

  const fontFamilyItems = useMemo(
    () => {
      const localFontFamilies = [
        { family: "Arial" },
        { family: "Georgia" },
        { family: "Tahoma" },
        { family: "Times New Roman" },
        { family: "Verdana" },
      ];
      const customFontFamilies = getResolvedCustomFonts(savedCustomFontList)
        .filter((row) => row.label)
        .map((row) => ({ family: row.label }));
      const seenFamilies = new Set();
      const orderedFontFamilies = [];

      const appendUniqueFamilies = (items) => {
        items.forEach((item) => {
          const key = item.family?.toLowerCase?.();
          if (key && !seenFamilies.has(key)) {
            seenFamilies.add(key);
            orderedFontFamilies.push(item);
          }
        });
      };

      appendUniqueFamilies(localFontFamilies);
      appendUniqueFamilies(customFontFamilies);
      //add google web fonts if required in RHS Text property
      // appendUniqueFamilies(googleWebFonts);

      return orderedFontFamilies;
    },
    [savedCustomFontList],
    //commented out google web fonts to avoid re-rendering when google web fonts are changed
    // [savedCustomFontList, googleWebFonts],
  );

  let locked = false;
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        rightPanelRef.current &&
        !rightPanelRef.current.contains(event.target)
      ) {
        // Collapse all expanded panels
        setExpanded({
          panel1: false,
          panel2: false,
          panel3: false,
          panel4: false,
          panel5: false,
          panel6: false,
          panel7: false,
          panel8: false,
          panel9: false,
          panel10: false,
          panel11: false,
          panel12: false,
          panel13: false,
        });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const selectedLayerIndex =
    layerCompData?.findIndex(
      (selComp) => selComp?.id === selectedComponent?.id,
    ) ?? -1;

  if (
    selectedComponent?.componentType !== undefined &&
    layerCompData?.length > 0 &&
    selectedComponent?.componentType !== "default" &&
    selectedLayerIndex >= 0
  ) {
    locked = layerCompData[selectedLayerIndex]?.componentStyles?.lockBoolean;
  }
  let hideFlag =
    selectedLayerIndex >= 0
      ? layerCompData?.[selectedLayerIndex]?.componentStyles?.hideBoolean
      : undefined;
  const currentAspectRatioLocked = !!isAspectRatioLocked;
  const defaultTabValue =
    window.localStorage.getItem("rightPanelTabValue") || 0;

  const { t } = useTranslation();
  const [checkBoxRepeat, setCheckBoxRepeat] = useState(undefined);
  const [hitAreaInfoOpen, setHitAreaInfoOpen] = useState(false);
  const hitAreaInfoCloseTimeoutRef = useRef(null);
  const [isHitAreaModalOpen, setIsHitAreaModalOpen] = useState(false);
  const [lineHeightProp, setLineHeightProp] = useState("");
  const [fontSize, setFontSize] = useState("");
  const [fontFamily, setFontFamily] = useState("Nunito Sans");
  const [fontWeight, setFontWeight] = useState("");
  const [characterSpacing, setCharacterSpacing] = useState("");
  const [borderWidth, setBorderWidth] = useState(1);
  const [borderStyle, setBorderStyle] = useState("solid");
  const [targetLink, setTargetLink] = useState("https://");
  const [cornerCount, setCornerCount] = useState("");
  const [borderRadius, setBorderRadius] = useState(
    selectedComponent?.componentStyles?.scrollBorderRadius,
  );
  const [scrollbarArrow, setScrollbarArrow] = useState({
    thumbWidth: 0,
    thumbHeight: 0,
    thumbColor: "#000000",
    thumbRadius: 2,
    trackWidth: 0,
    trackHeight: 0,
    trackColor: "#000000",
    trackRadius: 2,
    arrowWidth: 0,
    arrowHeight: 0,
  });
  const [scrollDimensionData, setScrollDimensionData] = useState({
    dimensions: {
      dimension: ["Width", "Height"],
      track: ["Width"],
      width: "true",
      height: "true",
      color: "true",
      radius: "true",
    },
  });
  // Track open fill/border/track pickers so RHS sync does not fight live palette drag.
  const fillPickerOpenRef = useRef(false);
  const borderPickerOpenRef = useRef(false);
  const trackPickerOpenRef = useRef(false);
  const scrollThumbPickerOpenRef = useRef(false);
  const scrollThumbBgPickerOpenRef = useRef(false);

  useEffect(() => {
    let defaultValues = selectedComponent?.componentStyles;
    if (!defaultValues) return;

    setCharacterSpacing(roundTo2Decimals(defaultValues?.letterSpacing));
    setFontSize(
      roundTo2Decimals(defaultValues?.fontSize ?? defaultValues?.datafontSize),
    );
    setFontFamily(defaultValues?.fontFamily);
    setFontWeight(defaultValues?.fontWeight);
    setLineHeightProp(roundTo2Decimals(defaultValues?.lineHeight));
    let rgbColor1 = defaultValues?.color?.includes("rgb")
      ? defaultValues?.color
      : convertHex(defaultValues?.color, 100);
    setTextColor(rgbColor1);

    // Never push fill/border back into ChromePicker while that picker is open —
    // it causes a feedback loop (new color blinks, then old color re-applies).
    if (!fillPickerOpenRef.current) {
      let rgbColor = defaultValues?.backgroundColor?.includes("rgb")
        ? defaultValues?.backgroundColor
        : convertHex(defaultValues?.backgroundColor, 100);
      setButtonColor(rgbColor);
    }

    let rgbTextBgColor = defaultValues?.textBgColor?.includes("rgb")
      ? defaultValues?.textBgColor
      : convertHex(defaultValues?.textBgColor, 100);
    setTextBgColor(rgbTextBgColor);
    if (!trackPickerOpenRef.current) {
      let rgbScrollColor = defaultValues?.thumbColor?.includes("rgb")
        ? defaultValues?.thumbColor
        : convertHex(defaultValues?.thumbColor, 100);
      setScrollColor(rgbScrollColor);
    }

    let rgbFontColorISI = defaultValues?.expandClose?.fontColorISI?.includes(
      "rgb",
    )
      ? defaultValues?.expandClose?.fontColorISI
      : convertHex(defaultValues?.expandClose?.fontColorISI, 100);
    setFontColorISI(rgbFontColorISI);

    let rgbTextBgColorISI =
      defaultValues?.expandClose?.textBgColorISI?.includes("rgb")
        ? defaultValues?.expandClose?.textBgColorISI
        : convertHex(defaultValues?.expandClose?.textBgColorISI, 100);
    setTextBgColorISI(rgbTextBgColorISI);
    if (defaultValues?.border) {
      let borderValue = defaultValues?.border?.split(" ");
      let borderColorValue = defaultValues?.border?.includes("rgb")
        ? defaultValues?.border?.substr(defaultValues?.border?.indexOf("rgb"))
        : convertHex(borderValue[2], 100);
      let rgbColor2 =
        borderColorValue.startsWith("rgb") &&
        typeof borderColorValue === "string"
          ? convertRgbaStrToObj(borderColorValue)
          : borderColorValue;

      if (!borderPickerOpenRef.current) {
        setBorderColor(rgbColor2);
      }
      let borderValueForPolygon = borderValue[1].substring(
        0,
        borderValue[1].indexOf("p"),
      );
      let borderValueForComp = 0;

      if (selectedComponent?.textComponentType) {
        borderValueForComp =
          selectedComponent?.textComponentType?.addContent === "polygonShape" ||
          selectedComponent?.textComponentType?.addContent === "hexagonShape"
            ? parseFloat(borderValueForPolygon)
            : parseFloat(borderValue[1]);
      } else {
        borderValueForComp = parseFloat(borderValue[1]);
      }

      setBorderWidth(
        roundTo2Decimals(
          Number.isNaN(borderValueForComp) ? 0 : borderValueForComp,
        ),
      );
      setBorderStyle(borderValue[0]);
      setRadiusTRBL({
        borderTopLeftRadius: roundTo2Decimals(
          defaultValues.borderTopLeftRadius,
        ),
        borderTopRightRadius: roundTo2Decimals(
          defaultValues.borderTopRightRadius,
        ),
        borderBottomLeftRadius: roundTo2Decimals(
          defaultValues.borderBottomLeftRadius,
        ),
        borderBottomRightRadius: roundTo2Decimals(
          defaultValues.borderBottomRightRadius,
        ),
      });
      setPaddingTRBL({
        paddingTop: roundTo2Decimals(defaultValues.paddingTop),
        paddingRight: roundTo2Decimals(defaultValues.paddingRight),
        paddingBottom: roundTo2Decimals(defaultValues.paddingBottom),
        paddingLeft: roundTo2Decimals(defaultValues.paddingLeft),
      });
    }

    setURLValue("");
    setTargetLink(defaultValues?.targetLink);
    setCheckBoxRepeat(defaultValues?.repeat);
  }, [
    selectedComponent?.id,
    selectedComponent?.componentType,
    selectedComponent?.componentStyles?.color,
    selectedComponent?.componentStyles?.backgroundColor,
    selectedComponent?.componentStyles?.border,
    selectedComponent?.componentStyles?.fontFamily,
    selectedComponent?.componentStyles?.fontSize,
    selectedComponent?.componentStyles?.fontWeight,
    selectedComponent?.componentStyles?.letterSpacing,
    selectedComponent?.componentStyles?.lineHeight,
    selectedComponent?.componentStyles?.targetLink,
    selectedComponent?.componentStyles?.textBgColor,
    selectedComponent?.componentStyles?.thumbColor,
    selectedComponent?.componentStyles?.borderTopLeftRadius,
    selectedComponent?.componentStyles?.borderTopRightRadius,
    selectedComponent?.componentStyles?.borderBottomLeftRadius,
    selectedComponent?.componentStyles?.borderBottomRightRadius,
    selectedComponent?.componentStyles?.paddingTop,
    selectedComponent?.componentStyles?.paddingRight,
    selectedComponent?.componentStyles?.paddingBottom,
    selectedComponent?.componentStyles?.paddingLeft,
    selectedComponent?.componentStyles?.repeat,
    selectedComponent?.componentStyles?.expandClose?.fontColorISI,
    selectedComponent?.componentStyles?.expandClose?.textBgColorISI,
    selectedComponent?.textComponentType?.addContent,
  ]);

  // Froala init click only when selection identity changes — never on color drag.
  useEffect(() => {
    if (
      (selectedComponent?.componentType === "Button" ||
        selectedComponent?.componentType === "Text") &&
      createFroalaInstance?.current?.length > 0 &&
      createFroalaInstance?.current[0] &&
      !createFroalaInstance?.current[0]?.editorInitialized &&
      selectedComponent?.id &&
      document.getElementById(selectedComponent.id)
    ) {
      document.getElementById(selectedComponent.id).click();
    }
  }, [selectedComponent?.id, selectedComponent?.componentType]);

  useEffect(() => {
    if (layerId.type === "Image") {
      setURLValue("");
      setTargetLink("https://");
    }

    setCheckBoxRepeat(false);
  }, [layerId.type]);

  useEffect(() => {
    const bgColor = canvasDimension?.backgroundColor;
    let rgbBgColor;

    if (typeof bgColor === "string") {
      rgbBgColor = bgColor.includes("rgb") ? bgColor : convertHex(bgColor, 100);
    } else if (bgColor && typeof bgColor === "object") {
      rgbBgColor = `rgba(${bgColor.r}, ${bgColor.g}, ${bgColor.b}, ${bgColor.a})`;
    }
    if (rgbBgColor) {
      setBgColorCanvas(rgbBgColor);
      setCanvasDimension({ ...canvasDimension, backgroundColor: rgbBgColor });
    }
    
  }, []);

  useEffect(() => {
    setBorderRadius(selectedComponent?.componentStyles?.scrollBorderRadius);
    if (!scrollThumbBgPickerOpenRef.current) {
      setScrollThumbBgColor(
        rgbaStringToObject(
          selectedComponent?.componentStyles?.scrollThumbBgColor,
        ),
      );
    }
    if (!scrollThumbPickerOpenRef.current) {
      setScrollThumbColor(
        rgbaStringToObject(
          selectedComponent?.componentStyles?.scrollThumbColor,
        ),
      );
    }
  }, [selectedComponent]);

  const [URLValue, setURLValue] = useState("");
  const {
    refFontColorISI,
    colorPickerFontColorISI,
    setColorPickerFontColorISI,
  } = useColorpickerFontColorISI(false);
  const {
    refTextBgColorISI,
    colorPickerTextBgColorISI,
    setColorPickerTextBgColorISI,
  } = useColorpickerTextBgColorISI(false);
  const { refButtonColor, displayColorPicker, setDisplayColorPicker } =
    useDisplaycolorpicker(false);

  const { refBorder, displayColorPickerBorder, setDisplayColorPickerBorder } =
    useDisplaycolorpickerBorder(false);
  const {
    refFontColor,
    displayColorPickerFontColor,
    setDisplayColorPickerFontColor,
  } = useDisplaycolorpickerFontColor(false);

  const {
    refScrollColor,
    displayColorPickerScrollColor,
    setDisplayColorPickerScrollColor,
  } = useDisplaycolorpickerScrollColor(false);

  const {
    refBgColor,
    displayColorPickerBgColor,
    setDisplayColorPickerBgColor,
  } = useDisplaycolorpickerBgColor(false);
  const { refTextBg, displaycolorpickerTextBg, setDisplaycolorpickerTextBg } =
    useDisplaycolorpickerTextBg(false);
  const {
    refScrollThumbColor,
    scrollThumbColorPicker,
    setScrollThumbColorPicker,
  } = useScrollThumbcolorpicker(false);
  const {
    refScrollThumbBgColor,
    scrollThumbBgColorPicker,
    setScrollThumbBgColorPicker,
  } = useScrollThumbBgColorPicker(false);

  useEffect(() => {
    // ;
    let tempSelect = JSON.parse(JSON.stringify(selectedComponent));
    if (Object.values(selectedComponent).length === 0) return;
    if (tempSelect.componentStyles) {
      tempSelect.componentStyles = normalizeComponentStylesDecimals(
        tempSelect.componentStyles,
      );
    }
    // Sync transform values for single selection (including nested scrollbar text).
    // Skip only while a true multi-select group is active.
    const isSingleSelection =
      multiSelectedComps.length === 0 ||
      (multiSelectedComps.length === 1 &&
        multiSelectedComps[0]?.id === selectedComponent?.id);
    if (isSingleSelection) {
      setUpdatedValue(tempSelect);
    }
    setLocalRightProps(tempSelect);
  }, [selectedComponent]);

  const handleClickFontColorISI = () => {
    setColorPickerFontColorISI(!colorPickerFontColorISI);
  };
  const handleClicktextBgColorISI = () => {
    setColorPickerTextBgColorISI(!colorPickerTextBgColorISI);
  };
  const handleClickSwatchFontCOlor = () => {
    setDisplayColorPickerFontColor(!displayColorPickerFontColor);
  };
  const handleTextBgColor = () => {
    setDisplaycolorpickerTextBg(!displaycolorpickerTextBg);
  };
  const snapshotRgbColor = (cssOrObj, fallbackRgb) => {
    const css =
      typeof cssOrObj === "string"
        ? cssOrObj
        : cssOrObj
          ? `rgba(${cssOrObj?.r}, ${cssOrObj?.g}, ${cssOrObj?.b}, ${cssOrObj?.a})`
          : "";
    let rgb =
      typeof fallbackRgb === "object" && fallbackRgb
        ? { ...fallbackRgb }
        : fallbackRgb;
    if (typeof cssOrObj === "object" && cssOrObj) {
      rgb = { ...cssOrObj };
    } else if (typeof css === "string" && css.includes("rgb")) {
      const parsed = rgbaStringToObject(css) || convertRgbaStrToObj(css);
      if (parsed) rgb = parsed;
    }
    return { css, rgb };
  };

  const handleClickSwatch = () => {
    // Opening fill picker: snapshot current color so X can cancel/revert.
    if (!displayColorPicker && selectedComponent?.componentStyles) {
      const current =
        selectedComponent.componentStyles.backgroundColor || buttonColor;
      fillColorSnapshotRef.current = snapshotRgbColor(current, buttonColor);
      fillPickerDismissRef.current = null;
      latestButtonFillRef.current = fillColorSnapshotRef.current.rgb || buttonColor;
      fillPickerOpenRef.current = true;
    } else {
      fillPickerOpenRef.current = false;
    }
    setDisplayColorPicker(!displayColorPicker);
  };
  const handleClickSwatchBorder = () => {
    if (!displayColorPickerBorder && selectedComponent?.componentStyles) {
      const borderCss = selectedComponent.componentStyles.border;
      const borderRgbFromCss =
        typeof borderCss === "string" && borderCss.includes("rgb")
          ? convertRgbaStrToObj(
              borderCss.substr(borderCss.indexOf("rgb")),
            ) || borderColor
          : borderColor;
      borderColorSnapshotRef.current = {
        css: borderCss,
        rgb:
          typeof borderColor === "object" && borderColor
            ? { ...borderColor }
            : borderRgbFromCss,
      };
      borderPickerDismissRef.current = null;
      latestBorderColorRef.current = borderColorSnapshotRef.current.rgb;
      borderPickerOpenRef.current = true;
    } else {
      borderPickerOpenRef.current = false;
    }
    setDisplayColorPickerBorder(!displayColorPickerBorder);
  };
  const handleClickSwatchScroll = () => {
    if (!displayColorPickerScrollColor && selectedComponent?.componentStyles) {
      const current =
        selectedComponent.componentStyles.thumbColor || scrollColor;
      trackColorSnapshotRef.current = snapshotRgbColor(current, scrollColor);
      trackPickerDismissRef.current = null;
      latestScrollColorRef.current =
        trackColorSnapshotRef.current.rgb || scrollColor;
      trackPickerOpenRef.current = true;
    } else {
      trackPickerOpenRef.current = false;
    }
    setDisplayColorPickerScrollColor(!displayColorPickerScrollColor);
  };
  const handleClickSwatchScrollbar = () => {
    if (!scrollThumbColorPicker && selectedComponent?.componentStyles) {
      const current =
        selectedComponent.componentStyles.scrollThumbColor || scrollThumbColor;
      scrollThumbColorSnapshotRef.current = snapshotRgbColor(
        current,
        scrollThumbColor,
      );
      scrollThumbPickerDismissRef.current = null;
      latestScrollThumbColorRef.current =
        scrollThumbColorSnapshotRef.current.rgb || scrollThumbColor;
      scrollThumbPickerOpenRef.current = true;
    } else {
      scrollThumbPickerOpenRef.current = false;
    }
    setScrollThumbColorPicker(!scrollThumbColorPicker);
  };
  const handleClickSwatchScrollbarThumbBg = () => {
    if (!scrollThumbBgColorPicker && selectedComponent?.componentStyles) {
      const current =
        selectedComponent.componentStyles.scrollThumbBgColor ||
        scrollThumbBgColor;
      scrollThumbBgColorSnapshotRef.current = snapshotRgbColor(
        current,
        scrollThumbBgColor,
      );
      scrollThumbBgPickerDismissRef.current = null;
      latestScrollThumbBgColorRef.current =
        scrollThumbBgColorSnapshotRef.current.rgb || scrollThumbBgColor;
      scrollThumbBgPickerOpenRef.current = true;
    } else {
      scrollThumbBgPickerOpenRef.current = false;
    }
    setScrollThumbBgColorPicker(!scrollThumbBgColorPicker);
  };

  const handleChangeBorderRadius = (e) => {
    let tempSlected = { ...selectedComponent };
    setBorderRadius(e.target.value);
    tempSlected.componentStyles.scrollBorderRadius = e.target.value;
    setSelectedComponent(tempSlected);
  };
  const handleClickSwatchBgColor = (from) => {
    if (from === "fromGlobal") setCanvasBgChange(true);
    if (!displayColorPickerBgColor) {
      const bg = canvasDimension?.backgroundColor;
      let rgb =
        typeof bg === "string"
          ? rgbaStringToObject(bg)
          : bg && typeof bg === "object"
            ? {
                r: Number(bg.r),
                g: Number(bg.g),
                b: Number(bg.b),
                a: Number(bg.a),
              }
            : null;
      if (!rgb && typeof bg === "string") {
        const match = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
        if (match) {
          rgb = {
            r: Number(match[1]),
            g: Number(match[2]),
            b: Number(match[3]),
            a: 1,
          };
        }
      }
      if (rgb) {
        const next = { ...rgb, a: 1 };
        myCanvasRef.current = next;
        setBgColorCanvas(next);
        setCanvasDimension({
          ...canvasDimension,
          backgroundColor: next,
        });
      }
    }
    setDisplayColorPickerBgColor(!displayColorPickerBgColor);
  };

  const changeTargetLink = (e, blur) => {
    setTargetLink(e.target.value);
    if (blur !== "blur") return;

    const nextTargetLink = e.target.value;
    const tempSelected = { ...selectedComponent };

    if (!tempSelected.componentStyles) return;

    tempSelected.componentStyles = {
      ...tempSelected.componentStyles,
      targetLink: nextTargetLink,
    };
    setSelectedComponent(tempSelected);

    // Preview/export HTML is generated from layerCompData, not selectedComponent.
    const layerIdx = layerCompData.findIndex(
      (entry) => entry.id === selectedComponent.id,
    );
    if (layerIdx < 0) return;

    const nextLayers = [...layerCompData];
    nextLayers[layerIdx] = {
      ...nextLayers[layerIdx],
      componentStyles: {
        ...nextLayers[layerIdx].componentStyles,
        targetLink: nextTargetLink,
      },
    };
    setLayerCompData(nextLayers);
  };

  const clearHitAreaInfoCloseTimeout = () => {
    if (hitAreaInfoCloseTimeoutRef.current) {
      window.clearTimeout(hitAreaInfoCloseTimeoutRef.current);
      hitAreaInfoCloseTimeoutRef.current = null;
    }
  };

  const openHitAreaInfoTooltip = () => {
    clearHitAreaInfoCloseTimeout();
    setHitAreaInfoOpen(true);
  };

  const scheduleCloseHitAreaInfoTooltip = () => {
    clearHitAreaInfoCloseTimeout();
    hitAreaInfoCloseTimeoutRef.current = window.setTimeout(() => {
      setHitAreaInfoOpen(false);
      hitAreaInfoCloseTimeoutRef.current = null;
    }, 150);
  };

  useEffect(
    () => () => {
      clearHitAreaInfoCloseTimeout();
    },
    [],
  );

  const openHitAreaModal = () => {
    if (
      selectedComponent?.componentType !== "Image" ||
      !selectedComponent?.componentStyles
    ) {
      return;
    }
    setIsHitAreaModalOpen(true);
  };

  const saveHitAreaFromModal = (modalHitAreas = [], rawNextSequence = 1, options = {}) => {
    if (
      selectedComponent?.componentType !== "Image" ||
      !selectedComponent?.componentStyles
    ) {
      return;
    }

    const savedHitAreas = Array.isArray(modalHitAreas) ? modalHitAreas : [];
    const savedSequence = Math.max(1, Number(rawNextSequence) || 1);
    const rawHitAreaDraggerWidth = Number(options?.hitAreaDraggerWidth);
    const hasHitAreaDraggerWidth =
      Number.isFinite(rawHitAreaDraggerWidth) && rawHitAreaDraggerWidth > 0;

    // Sync to the right-panel selection state
    const updatedComponent = { ...selectedComponent };
    updatedComponent.componentStyles = {
      ...updatedComponent.componentStyles,
      hitAreas: savedHitAreas,
      hitAreaSequence: savedSequence,
      ...(hasHitAreaDraggerWidth
        ? { hitAreaDraggerWidth: rawHitAreaDraggerWidth }
        : {}),
    };
    setSelectedComponent(updatedComponent);

    // CRITICAL: also write to layerCompData.
    // Preview/export HTML is generated from layerCompData (via downLoad()),
    // not from selectedComponent. Without this update the hit areas are
    // invisible to the HTML generator and never appear in the preview.
    const layerIdx = layerCompData.findIndex(
      (entry) => entry.id === selectedComponent.id,
    );
    let nextLayers = layerCompData;
    if (layerIdx >= 0) {
      nextLayers = [...layerCompData];
      nextLayers[layerIdx] = {
        ...nextLayers[layerIdx],
        componentStyles: {
          ...nextLayers[layerIdx].componentStyles,
          hitAreas: savedHitAreas,
          hitAreaSequence: savedSequence,
          targetLink:
            updatedComponent.componentStyles?.targetLink ??
            nextLayers[layerIdx].componentStyles?.targetLink,
          ...(hasHitAreaDraggerWidth
            ? { hitAreaDraggerWidth: rawHitAreaDraggerWidth }
            : {}),
        },
      };
      setLayerCompData(nextLayers);
    }

    let nextAnimationObject = animationObject;
    // Sync hit area animation into animationObject so that EditorHeader.js
    // picks it up when building the GSAP entries for export / preview.
    if (typeof setAnimationObject === "function") {
      // Collect every hit area ID tied to this image so stale entries are removed.
      const oldHitAreaIds = new Set(
        [
          ...(layerCompData[layerIdx]?.componentStyles?.hitAreas || []),
          ...savedHitAreas,
        ]
          .filter((ha) => ha?.id)
          .map((ha) => ha.id),
      );

      nextAnimationObject = { ...(animationObject || {}) };

      // Remove stale entries left over from deleted / replaced hit areas.
      oldHitAreaIds.forEach((id) => {
        delete nextAnimationObject[id];
      });

      // Add / overwrite entries for every current hit area.
      savedHitAreas.forEach((hitArea) => {
        if (hitArea.hideBoolean || !hitArea.id) return;

        nextAnimationObject[hitArea.id] = {
          animation: buildHitAreaAnimationArray(
            hitArea,
            getHitAreaKeyframesForAnimation(hitArea),
          ),
        };
      });

      setAnimationObject(nextAnimationObject);
    }

    if (persistBannerCanvas) {
      persistBannerCanvas({
        layerCompData: nextLayers,
        animationObject: nextAnimationObject,
      })
        .then((didSave) => {
          if (didSave) {
            toast.success(
              <div className="notificationText d-flex">
                Hit area saved successfully.
              </div>
            );
          } else {
            toast.error(
              <div className="notificationText">
                Hit area could not be saved. Please try again.
              </div>
            );
          }
        })
        .catch(() => {
          toast.error(
            <div className="notificationText">
              Hit area could not be saved. Please try again.
            </div>
          );
        });
    } else {
      toast.success(
        <div className="notificationText d-flex">Hit area saved successfully.</div>
      );
    }

    if (triggerUndoCapture) {
      setTimeout(() => {
        triggerUndoCapture();
      }, 100);
    }

    setIsHitAreaModalOpen(false);
  };

  const selectedImageHitAreas = useMemo(() => {
    if (selectedComponent?.componentType !== "Image") return [];

    const layerEntry = layerCompData?.find(
      (entry) => entry.id === selectedComponent?.id,
    );
    const hitAreas =
      layerEntry?.componentStyles?.hitAreas ??
      selectedComponent?.componentStyles?.hitAreas;

    return Array.isArray(hitAreas) ? hitAreas : [];
  }, [layerCompData, selectedComponent]);

  const shouldShowEditAndAddHitArea = useMemo(
    () =>
      selectedImageHitAreas.length > 0 &&
      selectedImageHitAreas.some(
        (hitAreaItem) => !isDefaultHitAreaUrlValue(hitAreaItem?.targetLink),
      ),
    [selectedImageHitAreas],
  );

  const changeBorderStyle = (e) => {
    if (!selectedComponent?.id || !selectedComponent?.componentStyles) return;
    const borderValue = `${e.target.value} ${Number(borderWidth)}px rgba(${
      borderColor?.r
    },${borderColor?.g},${borderColor?.b},${borderColor?.a})`;

    setSelectedComponent((prev) => ({
      ...prev,
      componentStyles: {
        ...prev.componentStyles,
        border: borderValue,
      },
    }));
    setLayerCompData((prevData) =>
      prevData.map((comp) =>
        comp.id === selectedComponent.id
          ? {
              ...comp,
              componentStyles: {
                ...comp.componentStyles,
                border: borderValue,
              },
            }
          : comp,
      ),
    );
    setBorderStyle(e.target.value);
  };
  const changeBorderWidth = (e, blur) => {
    if (!selectedComponent?.componentStyles?.border) return;

    let val = getValidInput(e, "borderWidth", blur);
    if (val === -1) return;
    val = sanitizeDecimalFieldValue(
      val,
      blur,
      BORDER_DECIMAL_FIELDS,
      "borderWidth",
    );
    if (val === -1) return;

    setBorderWidth(val);

    if (shouldPreserveDecimalInput(val, blur)) return;

    const numericBorderWidth = parseFloat(val);
    const borderSize = roundTo2Decimals(
      Number.isNaN(numericBorderWidth) ? 0 : numericBorderWidth,
    );

    const nextBorder = `${borderStyle} ${borderSize}px rgba(${borderColor?.r},${borderColor?.g},${borderColor?.b},${borderColor?.a})`;
    const stylePatch = { border: nextBorder };

    applyShapeStrokeWidth(borderSize);

    // Patch only border so a just-applied fill color is not overwritten.
    setSelectedComponent((prev) => ({
      ...prev,
      componentStyles: {
        ...prev.componentStyles,
        ...stylePatch,
      },
    }));
    setLayerCompData((prevData) =>
      prevData.map((comp) =>
        comp.id === selectedComponent.id
          ? {
              ...comp,
              componentStyles: {
                ...comp.componentStyles,
                ...stylePatch,
              },
            }
          : comp,
      ),
    );
    if (blur === "blur") {
      layerCompData[layerCompData.length - 1].eachDrag = "no";
    } else {
      layerCompData[layerCompData.length - 1].eachDrag = "yes";
    }
  };

  const handleDimensions = (e, blur) => {
    let name = e.target.name;
    const isValidNegativeOne =
      (name === "left" || name === "top") &&
      String(e.target.value).trim() === "-1";
    let retVal = getValidInput(e, name, blur);

    if (retVal === -1 && !isValidNegativeOne) return;

    const decimalFields = ["left", "top", "width", "height"];
    retVal = sanitizeDecimalFieldValue(retVal, blur, decimalFields, name);
    if (retVal === -1 && !isValidNegativeOne) return;

    if (shouldPreserveDecimalInput(retVal, blur)) {
      let dimensionValue = {
        ...updatedValue,
        componentStyles: {
          ...updatedValue.componentStyles,
          [name]: retVal,
        },
      };
      setUpdatedValue(dimensionValue);
      return;
    }

    if (blur === "blur") {
      if (layerCompData[layerCompData.length - 1].eachDrag)
        layerCompData[layerCompData.length - 1].eachDrag = "no";
    } else {
      if (layerCompData[layerCompData.length - 1].eachDrag)
        layerCompData[layerCompData.length - 1].eachDrag = "yes";
    }
    let dimensionValue = {
      ...updatedValue,
      componentStyles: {
        ...updatedValue.componentStyles,
        [name]: retVal,
      },
    };

    setUpdatedValue(dimensionValue);

    // Patch only the changed dimension field so a just-applied fill color
    // (still settling in selectedComponent) is not overwritten by a stale spread.
    const stylePatch = { [name]: retVal };
    let tempSelected = {
      ...selectedComponent,
      componentStyles: {
        ...selectedComponent.componentStyles,
        ...stylePatch,
      },
    };
    if ((name == "width" || name == "height") && currentAspectRatioLocked) {
      handleCompAspectRatio(tempSelected, name, retVal);
    }

    setSelectedComponent((prev) => ({
      ...prev,
      componentStyles: {
        ...prev.componentStyles,
        ...stylePatch,
        ...(tempSelected.componentStyles.width !== undefined &&
        (name === "width" || name === "height") &&
        currentAspectRatioLocked
          ? {
              width: tempSelected.componentStyles.width,
              height: tempSelected.componentStyles.height,
            }
          : {}),
      },
    }));

    setLayerCompData((prevData) =>
      prevData.map((comp) =>
        comp.id === selectedComponent.id
          ? {
              ...comp,
              componentStyles: {
                ...comp.componentStyles,
                ...stylePatch,
                ...(tempSelected.componentStyles.width !== undefined &&
                (name === "width" || name === "height") &&
                currentAspectRatioLocked
                  ? {
                      width: tempSelected.componentStyles.width,
                      height: tempSelected.componentStyles.height,
                    }
                  : {}),
              },
            }
          : comp,
      ),
    );
    if (blur === "blur" && triggerUndoCapture) {
      setTimeout(() => {
        triggerUndoCapture();
      }, 100);
    }
  };

  const handleBlur = (e) => {
    let name = e.target.name;

    let dimensionValue = {
      ...updatedValue,
      componentStyles: {
        ...updatedValue.componentStyles,
        [name]: e.target.value === "" ? 0 : e.target.value,
      },
    };

    setUpdatedValue(dimensionValue);
    if (selectedComponent) {
      let tempSelected = { ...selectedComponent };
      tempSelected.componentStyles.width =
        dimensionValue?.componentStyles?.width;
      tempSelected.componentStyles.height =
        dimensionValue?.componentStyles?.height;
      tempSelected.componentStyles.left = dimensionValue?.componentStyles?.left;
      tempSelected.componentStyles.top = dimensionValue?.componentStyles?.top;

      setSelectedComponent(tempSelected);

      // Trigger undo capture after blur
      if (triggerUndoCapture) {
        setTimeout(() => {
          triggerUndoCapture();
        }, 100);
      }
    }
  };
  const handleCornerCount = (e) => {
    setCornerCount(e.target.value);
  };
  const [paddingTRBL, setPaddingTRBL] = useState({
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
  });
  const [radiusTRBL, setRadiusTRBL] = useState({
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  });
  const [commonPadding, setCommonPadding] = useState(true);
  const [commonRadius, setCommonRadius] = useState(true);

  const handlePadding = (sides) => {
    if (sides === "common") setCommonPadding(true);
    else setCommonPadding(false);
  };
  const handleRadius = (sides) => {
    if (sides === "common") setCommonRadius(true);
    else setCommonRadius(false);
  };
  const changeRadius = (e, blur) => {
    const { name } = e.target;
    let val = getValidInput(e, name, blur);
    if (val === -1) return;
    val = sanitizeDecimalFieldValue(val, blur, BORDER_DECIMAL_FIELDS, name);
    if (val === -1) return;
    if (!selectedComponent?.componentStyles) return;

    const stylePatch =
      name === "borderTopLeftRadius" && commonRadius
        ? {
            borderTopLeftRadius: val,
            borderTopRightRadius: val,
            borderBottomLeftRadius: val,
            borderBottomRightRadius: val,
          }
        : { [name]: val };

    if (name === "borderTopLeftRadius" && commonRadius) {
      setRadiusTRBL({
        borderTopLeftRadius: val,
        borderTopRightRadius: val,
        borderBottomLeftRadius: val,
        borderBottomRightRadius: val,
      });
    } else {
      setRadiusTRBL({ ...radiusTRBL, [name]: val });
    }

    if (blur === "blur") {
      layerCompData[layerCompData.length - 1].eachDrag = "no";
    } else {
      layerCompData[layerCompData.length - 1].eachDrag = "yes";
    }

    // Patch only radius fields so a freshly applied fill color is preserved.
    setSelectedComponent((prev) => ({
      ...prev,
      componentStyles: {
        ...prev.componentStyles,
        ...stylePatch,
      },
    }));
    setLayerCompData((prevData) =>
      prevData.map((comp) =>
        comp.id === selectedComponent.id
          ? {
              ...comp,
              componentStyles: {
                ...comp.componentStyles,
                ...stylePatch,
              },
            }
          : comp,
      ),
    );
  };

  const changePadding = (e, blur) => {
    const { name } = e.target;
    let val = getValidInput(e, name, blur);
    if (val === -1) return;
    val = sanitizeDecimalFieldValue(val, blur, BORDER_DECIMAL_FIELDS, name);
    if (val === -1) return;
    if (!selectedComponent?.componentStyles) return;

    const stylePatch =
      name === "paddingTop" && commonPadding
        ? {
            paddingTop: val,
            paddingRight: val,
            paddingBottom: val,
            paddingLeft: val,
          }
        : { [name]: val };

    if (name === "paddingTop" && commonPadding) {
      setPaddingTRBL({
        paddingTop: val,
        paddingRight: val,
        paddingBottom: val,
        paddingLeft: val,
      });
    } else {
      setPaddingTRBL({ ...paddingTRBL, [name]: val });
    }

    if (blur === "blur") {
      layerCompData[layerCompData.length - 1].eachDrag = "no";
    } else {
      layerCompData[layerCompData.length - 1].eachDrag = "yes";
    }

    // Patch only padding fields so a freshly applied fill color is preserved.
    setSelectedComponent((prev) => ({
      ...prev,
      componentStyles: {
        ...prev.componentStyles,
        ...stylePatch,
      },
    }));
    setLayerCompData((prevData) =>
      prevData.map((comp) =>
        comp.id === selectedComponent.id
          ? {
              ...comp,
              componentStyles: {
                ...comp.componentStyles,
                ...stylePatch,
              },
            }
          : comp,
      ),
    );
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      // console.log("api called");
    }, 500);

    return () => clearTimeout(timer);
  }, [fontSize]);
  const [localRightProps, setLocalRightProps] = useState({});

  const fontFamilyConfig = (value) => {
    if (selectedComponent) {
      let tempSelect = { ...selectedComponent };
      tempSelect.componentStyles.fontFamily = value;
      setSelectedComponent(tempSelect);
      let tempLayerCompData = [...layerCompData];
      tempLayerCompData[
        layerCompData.findIndex(
          (selComp) => selComp.id === selectedComponent.id,
        )
      ].componentStyles.fontFamily = tempSelect.componentStyles.fontFamily;
      setLayerCompData(tempLayerCompData);
    } else {
    }
    setundoFlag(true);
  };
  const handleFontFamily = (e) => {
    let eventData = e.target.value;
    let tempSelect = Object.assign(selectedComponent);
    let tempLayerCompData = JSON.parse(JSON.stringify(layerCompData));

    tempSelect.componentStyles.fontFamily = e.target.value;
    const isCustomFont = getResolvedCustomFonts(savedCustomFontList).some(
      (row) => row.label === e.target.value,
    );
    if (
      ["Arial", "Georgia", "Tahoma", "Times New Roman", "Verdana"].includes(
        e.target.value,
      ) ||
      isCustomFont
    ) {
      setFontFamily(e.target.value);
      fontFamilyConfig(e.target.value);
      setFontWeightItems(["normal", "bold"]);
      setSelectedComponent(tempSelect);
    } else {
      let fontWeight = fontFamilyItems.filter(
        (item) => item.family === eventData,
      )[0].variants;
      fontWeight = [
        "normal",
        "bold",
        // ...fontWeight.filter((variant) => /^\d+$/.test(variant)),
      ];
      let familiesToLoadWithWeight = `${e.target.value}:wght@`;
      fontWeight.forEach((weight) => {
        familiesToLoadWithWeight = familiesToLoadWithWeight.concat(
          `0,${weight};`,
        );
      });
      setFontWeightItems(fontWeight);
      WebFont.load({
        google: {
          families: [familiesToLoadWithWeight.concat("&display=swap")],
        },
        active: function () {
          setFontFamily(eventData);
          fontFamilyConfig(eventData);
          setSelectedComponent(tempSelect);
          tempLayerCompData[
            layerCompData.findIndex(
              (selComp) => selComp.id === selectedComponent.id,
            )
          ].componentStyles.fontFamily = tempSelect.componentStyles.fontFamily;
          setLayerCompData(tempLayerCompData);
        },
      });
    }
  };

  const handleTextPropsOnchange = (value, compPropname) => {
    if (!selectedComponent?.id) return;

    let tempSelected = {
      ...selectedComponent
    };

    if (compPropname === "lineHeight") {
      tempSelected.componentStyles.lineHeight = value;
      setLineHeightProp(value);
    } else if (compPropname === "fontSize") {
      tempSelected.componentStyles.fontSize = value;
      tempSelected.componentStyles.datafontSize = value;
      setFontSize(value);
    } else if (compPropname === "fontWeight") {
      setFontWeight(value);
      tempSelected.componentStyles.fontWeight = value;
      tempSelected.componentStyles.fontWeightBold = value;
    } else if (compPropname === "letterSpacing") {
      tempSelected.componentStyles.letterSpacing = value;
      setCharacterSpacing(value);
    }

    setLocalRightProps(tempSelected);
    setSelectedComponent(tempSelected);
    setLayerCompData((prevData) =>
      prevData.map((entry) =>
        entry.id === tempSelected.id
          ? {
              ...entry,
              componentStyles: {
                ...entry.componentStyles,
                ...tempSelected.componentStyles,
              },
            }
          : entry,
      ),
    );
  };

  // const fontAlignmentonClick = (type) => {
  //   const tempSelected = { ...selectedComponent };

  //   const tempLayercompData = [...layerCompData];
  //   switch (type) {
  //     case "leftAlign":
  //       tempSelected.componentStyles.textAlign = "left";
  //       tempLayercompData.forEach((entry, index) => {
  //         if (entry.id === tempSelected.id) {
  //           tempLayercompData[index].componentStyles.textAlign = "left";
  //         }
  //       });
  //       break;
  //     case "centerAlign":
  //       tempSelected.componentStyles.textAlign = "center";
  //       tempLayercompData.forEach((entry, index) => {
  //         if (entry.id === tempSelected.id) {
  //           tempLayercompData[index].componentStyles.textAlign = "center";
  //         }
  //       });
  //       break;

  //     case "rightAlign":
  //       tempSelected.componentStyles.textAlign = "right";
  //       tempLayercompData.forEach((entry, index) => {
  //         if (entry.id === tempSelected.id) {
  //           tempLayercompData[index].componentStyles.textAlign = "right";
  //         }
  //       });

  //       break;
  //     case "numberList":
  //       if (
  //         createFroalaInstance &&
  //         createFroalaInstance.current &&
  //         createFroalaInstance.current[froalaIndex] &&
  //         createFroalaInstance.current[froalaIndex].getEditor() &&
  //         froalaIndex !== undefined
  //       ) {
  //         createFroalaInstance.current[froalaIndex].editor.edit.on();
  //         createFroalaInstance.current[froalaIndex].editor.events.focus();

  //         createFroalaInstance.current[froalaIndex]
  //           .getEditor()
  //           .commands.selectAll();
  //         createFroalaInstance.current[froalaIndex]
  //           .getEditor()
  //           .lists.format("OL");
  //         let oldText =
  //           createFroalaInstance.current[froalaIndex]?.editor?.html.get();

  //         if (tempLayercompData[froalaIndex]?.froalaText) {
  //           tempLayercompData[froalaIndex].froalaText = oldText;
  //         }

  //         setLayerCompData(tempLayercompData);
  //       }
  //       createFroalaInstance.current[froalaIndex].getEditor().selection.clear();

  //       break;
  //     case "bullets":
  //       if (
  //         createFroalaInstance &&
  //         createFroalaInstance.current &&
  //         createFroalaInstance.current[froalaIndex] &&
  //         createFroalaInstance.current[froalaIndex].getEditor() &&
  //         froalaIndex !== undefined
  //       ) {
  //         createFroalaInstance.current[froalaIndex].editor.edit.on();
  //         createFroalaInstance.current[froalaIndex].editor.events.focus();
  //         createFroalaInstance.current[froalaIndex]
  //           .getEditor()
  //           .commands.selectAll();
  //         createFroalaInstance.current[froalaIndex]
  //           .getEditor()
  //           .lists.format("UL");
  //         let oldText =
  //           createFroalaInstance.current[froalaIndex]?.editor?.html.get();

  //         if (tempLayercompData[froalaIndex]?.froalaText) {
  //           tempLayercompData[froalaIndex].froalaText = oldText;
  //         }

  //         setLayerCompData(tempLayercompData);
  //       }
  //       createFroalaInstance.current[froalaIndex].getEditor().selection.clear();

  //       break;
  //     default:
  //       break;
  //   }
  //   setSelectedComponent(tempSelected);

  //   setLayerCompData(tempLayercompData);
  // };

  // Import the utility functions
  // import {
  //   updateAlignment,
  //   applyListFormat,
  //   getFroalaEditorInstance,
  // } from "./utility";

  const fontAlignmentonClick = (type) => {
    let updatedData;
    const activeComponent =
      layerCompData.find((entry) => entry.id === selectedComponent?.id) ||
      selectedComponent;
    const currentAlign = activeComponent?.componentStyles?.textAlign || "left";

    const alignmentType =
      (type === "centerAlign" && currentAlign === "center") ||
      (type === "rightAlign" && currentAlign === "right")
        ? "leftAlign"
        : type;

    switch (alignmentType) {
      case "leftAlign":
        updatedData = updateAlignment("left", selectedComponent, layerCompData);
        break;

      case "centerAlign":
        updatedData = updateAlignment(
          "center",
          selectedComponent,
          layerCompData,
        );
        break;

      case "rightAlign":
        updatedData = updateAlignment(
          "right",
          selectedComponent,
          layerCompData,
        );
        break;

      case "numberList":
        // Apply ordered list formatting
        const olLayerData = applyListFormat(
          "OL",
          froalaIndex,
          createFroalaInstance,
          layerCompData,
        );
        updatedData = {
          selectedComponent: { ...selectedComponent },
          layerCompData: olLayerData,
        };
        break;

      case "bullets":
        // Apply unordered list formatting
        const ulLayerData = applyListFormat(
          "UL",
          froalaIndex,
          createFroalaInstance,
          layerCompData,
        );
        updatedData = {
          selectedComponent: { ...selectedComponent },
          layerCompData: ulLayerData,
        };
        break;

      default:
        updatedData = {
          selectedComponent: { ...selectedComponent },
          layerCompData: [...layerCompData],
        };
        break;
    }

    if (
      ["leftAlign", "centerAlign", "rightAlign"].includes(alignmentType)
    ) {
      const editorRef = createFroalaInstance.current?.[froalaIndex];
      const editor = editorRef?.getEditor?.();
      const alignType = alignmentType.replace("Align", "");

      if (editor) {
        editor.edit.on();
        editor.events.focus();
        editor.commands.selectAll();
        editor.align.apply(alignType);

        const alignedHtml = editor.html.get();
        updatedData.layerCompData = updatedData.layerCompData.map((entry) =>
          entry.id === selectedComponent?.id
            ? { ...entry, froalaText: alignedHtml }
            : entry,
        );
        updatedData.selectedComponent = {
          ...updatedData.selectedComponent,
          froalaText: alignedHtml,
        };
        editor.selection.clear();
      }
    }

    // Update state with the new data
    setSelectedComponent(updatedData.selectedComponent);
    setLayerCompData(updatedData.layerCompData);
  };
  const listOnclick = (type) => {
    const tempSelected = { ...selectedComponent };

    const tempLayercompData = [...layerCompData];
    switch (type) {
      case "numberList":
        if (
          createFroalaInstance &&
          createFroalaInstance.current &&
          createFroalaInstance.current[froalaIndex] &&
          createFroalaInstance.current[froalaIndex].getEditor() &&
          froalaIndex !== undefined
        ) {
          createFroalaInstance.current[froalaIndex].editor.edit.on();
          createFroalaInstance.current[froalaIndex].editor.events.focus();
          createFroalaInstance.current[froalaIndex] &&
            createFroalaInstance.current[froalaIndex]
              .getEditor()
              .commands.selectAll();
          createFroalaInstance.current[froalaIndex]
            .getEditor()
            .lists.format("OL");
          let oldText =
            createFroalaInstance.current[froalaIndex]?.editor?.html.get();

          tempSelected.froalaText = oldText;
          if (!tempSelected.componentStyles) {
            tempSelected.componentStyles = {};
          }
          tempSelected.componentStyles.selectedIdnumberList = 1;

          if (tempLayercompData[froalaIndex]) {
            tempLayercompData[froalaIndex].froalaText = oldText;
            if (!tempLayercompData[froalaIndex].componentStyles) {
              tempLayercompData[froalaIndex].componentStyles = {};
            }
            tempLayercompData[
              froalaIndex
            ].componentStyles.selectedIdnumberList = 1;
          }
        }
        if (createFroalaInstance.current[froalaIndex]?.getEditor()) {
          createFroalaInstance.current[froalaIndex]
            .getEditor()
            .selection.clear();
        }

        break;
      case "bullets":
        if (
          createFroalaInstance &&
          createFroalaInstance.current &&
          createFroalaInstance.current[froalaIndex] &&
          createFroalaInstance.current[froalaIndex].getEditor() &&
          froalaIndex !== undefined
        ) {
          createFroalaInstance.current[froalaIndex].editor.edit.on();
          createFroalaInstance.current[froalaIndex].editor.events.focus();
          createFroalaInstance.current[froalaIndex]
            .getEditor()
            .commands.selectAll();
          createFroalaInstance.current[froalaIndex]
            .getEditor()
            .lists.format("UL");
          let oldText =
            createFroalaInstance.current[froalaIndex]?.editor?.html.get();

          tempSelected.froalaText = oldText;
          if (!tempSelected.componentStyles) {
            tempSelected.componentStyles = {};
          }
          tempSelected.componentStyles.selectedIdnumberList = 0;

          if (tempLayercompData[froalaIndex]) {
            tempLayercompData[froalaIndex].froalaText = oldText;
            if (!tempLayercompData[froalaIndex].componentStyles) {
              tempLayercompData[froalaIndex].componentStyles = {};
            }
            tempLayercompData[
              froalaIndex
            ].componentStyles.selectedIdnumberList = 0;
          }
        }
        if (createFroalaInstance.current[froalaIndex]?.getEditor()) {
          createFroalaInstance.current[froalaIndex]
            .getEditor()
            .selection.clear();
        }

        break;
      default:
        break;
    }
    setSelectedComponent(tempSelected);

    setLayerCompData(tempLayercompData);
  };
  // const fontStylesonClick = (type) => {
  //   if (selectedComponent) {
  //     let tempSelected = { ...selectedComponent };
  //     let tempLayercompData = [...layerCompData];

  //     switch (type) {
  //       case "bold":
  //         let clickBold = !tempSelected.componentStyles.boldClick;

  //         tempSelected.componentStyles.boldClick = clickBold;
  //         if (clickBold === true) {
  //           tempSelected.componentStyles.fontWeightBold = "bold";

  //           tempSelected.componentStyles.fontWeight = "bold";
  //         } else {
  //           tempSelected.componentStyles.fontWeightBold = "normal";
  //           tempSelected.componentStyles.fontWeight = "normal";
  //           tempSelected.componentStyles.boldClick = false;
  //         }
  //         tempLayercompData.forEach((entry, index) => {
  //           if (entry.id === tempSelected.id) {
  //             tempLayercompData[index].componentStyles.fontWeightBold =
  //               tempSelected.componentStyles.fontWeightBold;
  //             tempLayercompData[index].componentStyles.fontWeight =
  //               tempSelected.componentStyles.fontWeight;
  //           }
  //         });

  //         break;
  //       case "italic":
  //         let clickitalic = !tempSelected.componentStyles.italicClick;
  //         tempSelected.componentStyles.italicClick = clickitalic;
  //         if (clickitalic) {
  //           tempSelected.componentStyles.fontStyle = "italic";
  //         } else {
  //           tempSelected.componentStyles.fontStyle = "unset";
  //         }
  //         tempLayercompData.forEach((entry, index) => {
  //           if (entry.id === tempSelected.id) {
  //             tempLayercompData[index].componentStyles.fontStyle =
  //               tempSelected.componentStyles.fontStyle;
  //           }
  //         });
  //         break;
  //       case "underline":
  //         let clickUnderline = !tempSelected.componentStyles.underlineClick;

  //         tempSelected.componentStyles.underlineClick = clickUnderline;
  //         if (clickUnderline === true) {
  //           return (tempSelected.componentStyles.textDecUnderline =
  //             "underline");
  //         } else {
  //           tempSelected.componentStyles.textDecUnderline = "unset";
  //         }
  //         tempLayercompData.forEach((entry, index) => {
  //           if (entry.id === tempSelected.id) {
  //             tempLayercompData[index].componentStyles.textDecUnderline =
  //               tempSelected.componentStyles.textDecUnderline;
  //           }
  //         });
  //         break;
  //       case "uppercase":
  //         let clickUppercase = !tempSelected.componentStyles.uppercaseClicked;
  //         tempSelected.componentStyles.uppercaseClicked = clickUppercase;

  //         if (clickUppercase === true) {
  //           return (tempSelected.componentStyles.textTransform = "uppercase");
  //         } else {
  //           tempSelected.componentStyles.textTransform = "unset";
  //         }
  //         tempLayercompData.forEach((entry, index) => {
  //           if (entry.id === tempSelected.id) {
  //             tempLayercompData[index].componentStyles.textTransform =
  //               tempSelected.componentStyles.textTransform;
  //           }
  //         });
  //         break;
  //       case "strikeout":
  //         let clickStrikeThrough =
  //           !tempSelected.componentStyles.strikeThroughClicked;

  //         tempSelected.componentStyles.strikeThroughClicked =
  //           clickStrikeThrough;
  //         if (clickStrikeThrough === true) {
  //           return (tempSelected.componentStyles.textDecoration =
  //             "line-through");
  //         } else {
  //           tempSelected.componentStyles.textDecoration = "unset";
  //         }
  //         tempLayercompData.forEach((entry, index) => {
  //           if (entry.id === tempSelected.id) {
  //             tempLayercompData[index].componentStyles.textDecoration =
  //               tempSelected.componentStyles.textDecoration;
  //           }
  //         });
  //         break;
  //       default:
  //         break;
  //     }
  //     setSelectedComponent(tempSelected);
  //     setLayerCompData(tempLayercompData);
  //   }
  // };
  //2776

  const fontStylesonClick = (type, styleId) => {
  if (!selectedComponent) return;

  const updatedComponent = fontStyleToggle(selectedComponent, type);
  if (updatedComponent === selectedComponent) return;

  const toggleProperties = {
    bold: "boldClick",
    italic: "italicClick",
    underline: "underlineClick",
    uppercase: "uppercaseClicked",
    strikeout: "strikeThroughClicked",
  };

  const toggleProperty = toggleProperties[type];
  const isStyleActive = Boolean(
    updatedComponent.componentStyles[toggleProperty],
  );

  const currentStyles = [
    ...(updatedComponent.componentStyles.selectedFontStyle || []),
  ];

  updatedComponent.componentStyles.selectedFontStyle = isStyleActive
    ? [...new Set([...currentStyles, styleId])]
    : currentStyles.filter((id) => id !== styleId);

  setSelectedComponent(updatedComponent);

  setLayerCompData((currentComponents) =>
    updateComponentInArray(currentComponents, updatedComponent),
  );
};
  const [textColor, setTextColor] = useState({
    r: "0",
    g: "0",
    b: "0",
    a: "1",
  });
  const [textBgColorISI, setTextBgColorISI] = useState({
    r: "0",
    g: "0",
    b: "0",
    a: "1",
  });
  const [fontColorISI, setFontColorISI] = useState({
    r: "0",
    g: "0",
    b: "0",
    a: "1",
  });
  const [buttonColor, setButtonColor] = useState({
    r: "0",
    g: "0",
    b: "0",
    a: "1",
  });
  const [borderColor, setBorderColor] = useState({
    r: "0",
    g: "0",
    b: "0",
    a: "1",
  });
  // Fill/border picker draft/commit: snapshot on open, live preview while open,
  // X and outside-click both commit the new color to RHS + canvas.
  const fillColorSnapshotRef = useRef(null);
  const fillPickerDismissRef = useRef(null); // 'cancel' | 'commit' | null
  const latestButtonFillRef = useRef(buttonColor);
  const fillPickerWasOpenRef = useRef(false);
  const borderColorSnapshotRef = useRef(null);
  const borderPickerDismissRef = useRef(null);
  const latestBorderColorRef = useRef(borderColor);
  const borderPickerWasOpenRef = useRef(false);
  const trackColorSnapshotRef = useRef(null);
  const trackPickerDismissRef = useRef(null);
  const trackPickerWasOpenRef = useRef(false);
  const scrollThumbColorSnapshotRef = useRef(null);
  const scrollThumbPickerDismissRef = useRef(null);
  const scrollThumbPickerWasOpenRef = useRef(false);
  const scrollThumbBgColorSnapshotRef = useRef(null);
  const scrollThumbBgPickerDismissRef = useRef(null);
  const scrollThumbBgPickerWasOpenRef = useRef(false);

  const [textBgColor, setTextBgColor] = useState({
    r: "0",
    g: "0",
    b: "0",
    a: "1",
  });
  const [scrollColor, setScrollColor] = useState({
    r: "0",
    g: "0",
    b: "0",
    a: "1",
  });
  const [scrollThumbColor, setScrollThumbColor] = useState({
    r: "136",
    g: "136",
    b: "136",
    a: "1",
  });

  const [scrollThumbBgColor, setScrollThumbBgColor] = useState({
    r: "241",
    g: "241",
    b: "241",
    a: "1",
  });
  const latestScrollColorRef = useRef(scrollColor);
  const latestScrollThumbColorRef = useRef(scrollThumbColor);
  const latestScrollThumbBgColorRef = useRef(scrollThumbBgColor);
  const styles = reactCSS({
    default: {
      buttonColor: {
        width: "30px",
        height: "14px",
        marginLeft: "10px",
        borderRadius: "3px",
        border: "solid 1px #e1e1e1",
        background:
          typeof buttonColor === "string"
            ? buttonColor
            : `rgba(${buttonColor?.r}, ${buttonColor?.g}, ${buttonColor?.b}, ${buttonColor?.a})`,
      },
      borderColor: {
        width: "30px",
        height: "14px",
        marginLeft: "10px",
        borderRadius: "3px",
        border: "solid 1px #e1e1e1",
        background:
          typeof borderColor === "string"
            ? borderColor
            : `rgba(${borderColor?.r}, ${borderColor?.g}, ${borderColor?.b}, ${borderColor?.a})`,
      },
      scrollColor: {
        width: "30px",
        height: "14px",
        // position: "absolute",
        marginLeft: "10px",
        borderRadius: "3px",
        border: "solid 1px #e1e1e1",
        background:
          typeof scrollColor === "string"
            ? scrollColor
            : `rgba(${scrollColor?.r}, ${scrollColor?.g}, ${scrollColor?.b}, ${scrollColor?.a})`,
      },
      textColor: {
        width: "30px",
        height: "14px",
        marginLeft: "10px",
        borderRadius: "3px",
        border: "solid 1px #e1e1e1",
        background:
          typeof textColor === "string"
            ? textColor
            : `rgba(${textColor?.r}, ${textColor?.g}, ${textColor?.b}, ${textColor?.a})`,
      },
      textBgColorISI: {
        width: "30px",
        height: "14px",
        marginLeft: "10px",
        borderRadius: "3px",
        border: "solid 1px #e1e1e1",
        background:
          typeof textBgColorISI === "string"
            ? textBgColorISI
            : `rgba(${textBgColorISI?.r}, ${textBgColorISI?.g}, ${textBgColorISI?.b}, ${textBgColorISI?.a})`,
      },
      fontColorISI: {
        width: "30px",
        height: "14px",
        marginLeft: "10px",
        borderRadius: "3px",
        border: "solid 1px #e1e1e1",
        background:
          typeof fontColorISI === "string"
            ? fontColorISI
            : `rgba(${fontColorISI?.r}, ${fontColorISI?.g}, ${fontColorISI?.b}, ${fontColorISI?.a})`,
      },
      textBgColor: {
        width: "30px",
        height: "14px",
        marginLeft: "10px",
        borderRadius: "3px",
        border: "solid 1px #e1e1e1",
        background:
          typeof textBgColor === "string"
            ? textBgColor
            : `rgba(${textBgColor?.r}, ${textBgColor?.g}, ${textBgColor?.b}, ${textBgColor?.a})`,
      },
      backgroundColor: {
        width: "30px",
        height: "14px",
        marginLeft: "10px",
        borderRadius: "3px",
        border: "solid 1px #e1e1e1",
        background:
          typeof canvasDimension?.backgroundColor === "string"
            ? canvasDimension?.backgroundColor
            : `rgb(${canvasDimension?.backgroundColor?.r}, ${canvasDimension?.backgroundColor?.g}, ${canvasDimension?.backgroundColor?.b}, ${canvasDimension?.backgroundColor?.a})`,
      },
      scrollbarThumb: {
        width: "30px",
        height: "14px",
        // position: "absolute",
        marginLeft: "10px",
        borderRadius: "3px",
        border: "solid 1px #e1e1e1",
        background:
          typeof scrollThumbColor === "string"
            ? scrollThumbColor
            : `rgba(${scrollThumbColor?.r}, ${scrollThumbColor?.g}, ${scrollThumbColor?.b}, ${scrollThumbColor?.a})`,
      },
      scrollbarThumbBg: {
        width: "30px",
        height: "14px",
        // position: "absolute",
        marginLeft: "10px",
        borderRadius: "3px",
        border: "solid 1px #e1e1e1",
        background:
          typeof scrollThumbBgColor === "string"
            ? scrollThumbColor
            : `rgba(${scrollThumbBgColor?.r}, ${scrollThumbBgColor?.g}, ${scrollThumbBgColor?.b}, ${scrollThumbBgColor?.a})`,
      },
    },
  });

  const handleClose = () => {
    setDisplayColorPicker(displayColorPicker);
  };

  const toRgbaCss = (rgbOrCss) => {
    if (typeof rgbOrCss === "string") return rgbOrCss;
    if (!rgbOrCss) return "";
    return `rgba(${rgbOrCss.r}, ${rgbOrCss.g}, ${rgbOrCss.b}, ${rgbOrCss.a})`;
  };

  /**
   * Canvas-sized shapes keep their frame in the elevated stroke overlay, so the
   * shape's own border node stays unset and an imperative write there would
   * stick around — React never re-renders that property back.
   */
  const isOverlayPaintedBorder = () =>
    selectedComponent?.componentType === "Shape" &&
    isShapeMatchingCanvasSize(
      selectedComponent?.componentStyles,
      canvasDimension,
    );

  const paintSelectedComponentOnCanvas = (stylePatch = {}) => {
    const id = selectedComponent?.id;
    if (!id) return;
    const canvasNode = document.getElementById(id);
    if (!canvasNode) return;
    const isShapeLayer = selectedComponent?.componentType === "Shape";
    const isSvgShapeLayer =
      isShapeLayer &&
      isSvgShapeType(selectedComponent?.textComponentType?.addContent);
    const fillNode =
      canvasNode.querySelector("[data-button-fill], [data-border-target], [data-border-target]") ||
      canvasNode;
    // Only the inner node React re-renders the border on may be painted. The Rnd
    // wrapper has no React-managed border, so a write there is never reconciled
    // and stacks a second, permanent frame outside the real one.
    const borderNode = canvasNode.querySelector(
      "[data-border-target], [data-button-fill], [data-image-fill]",
    );
    if (stylePatch.backgroundColor != null) {
      // A shape's fill belongs to the shape, not to its layer box: rectangle and
      // circle paint it on the inner node so radius and border clip it, and the
      // SVG shapes carry it inside their data URI. The Rnd wrapper has no
      // React-managed background, so a write there floods the whole bounding
      // box and is never reconciled away.
      if (isShapeLayer) {
        canvasNode.style.removeProperty("background-color");
        if (!isSvgShapeLayer && fillNode !== canvasNode) {
          fillNode.style.backgroundColor = stylePatch.backgroundColor;
        }
      } else {
          fillNode.style.backgroundColor = stylePatch.backgroundColor;

          if (fillNode !== canvasNode) {
            canvasNode.style.removeProperty("background-color");
          }
      }
      const wrappers = canvasNode.querySelectorAll(
        "[data-button-fill], [data-image-fill], .froalaContent, .fr-box, .fr-wrapper, .fr-element",
      );
      wrappers.forEach((el) => {
        if (el.classList?.contains("fr-box") || el.classList?.contains("fr-wrapper") || el.classList?.contains("fr-element") || el.classList?.contains("froalaContent")) {
          el.style.backgroundColor = "transparent";
        }
      });
    }
    if (stylePatch.border != null && borderNode && !isOverlayPaintedBorder()) {
      canvasNode.style.removeProperty("border");
      borderNode.style.border = stylePatch.border;
    }

    if (stylePatch.thumbColor != null) {
      const trackNode = canvasNode.getElementsByClassName(
        "rc-scrollbars-track-v",
      )[0];
      if (trackNode) {
        trackNode.style.backgroundColor = stylePatch.thumbColor;
      }
    }
  };

  const patchSelectedLayerStyles = (stylePatch) => {
    const selectedId = selectedComponent?.id;
    if (!selectedId || !stylePatch) return;

    // Stable canvas draft — survives selectedComponent flicker while palette is open.
    if (
      typeof setCanvasStyleDraft === "function" &&
      (stylePatch.backgroundColor !== undefined ||
        stylePatch.border !== undefined)
    ) {
      setCanvasStyleDraft((prev) => ({
        id: selectedId,
        backgroundColor:
          stylePatch.backgroundColor !== undefined
            ? stylePatch.backgroundColor
            : prev?.id === selectedId
              ? prev.backgroundColor
              : undefined,
        border:
          stylePatch.border !== undefined
            ? stylePatch.border
            : prev?.id === selectedId
              ? prev.border
              : undefined,
      }));
    }

    setSelectedComponent((prev) => ({
      ...prev,
      componentStyles: {
        ...prev.componentStyles,
        ...stylePatch,
      },
    }));

    setLayerCompData((prevData) =>
      prevData.map((comp) => {
        if (String(comp.id) === String(selectedId)) {
          return {
            ...comp,
            componentStyles: {
              ...comp.componentStyles,
              ...stylePatch,
            },
          };
        }
        if (comp.scrollbarComponents) {
          return {
            ...comp,
            scrollbarComponents: comp.scrollbarComponents.map((scrollItem) =>
              String(scrollItem.id) === String(selectedId)
                ? {
                    ...scrollItem,
                    componentStyles: {
                      ...scrollItem.componentStyles,
                      ...stylePatch,
                    },
                  }
                : scrollItem,
            ),
          };
        }
        return comp;
      }),
    );

    // Live paint before React commit so palette drag feels immediate.
    paintSelectedComponentOnCanvas(stylePatch);
  };

  const applyButtonFillColor = (rgbOrCss, { updateSwatch = true } = {}) => {
    if (!selectedComponent?.id || !selectedComponent?.componentStyles) return;
    const nextBackgroundColor = toRgbaCss(rgbOrCss);
    if (!nextBackgroundColor || nextBackgroundColor.includes("undefined")) {
      return;
    }

    if (updateSwatch && typeof rgbOrCss !== "string" && rgbOrCss) {
      setButtonColor(rgbOrCss);
      latestButtonFillRef.current = rgbOrCss;
    }

    patchSelectedLayerStyles({ backgroundColor: nextBackgroundColor });
  };

  const applyButtonBorderColor = (rgb) => {
    if (!selectedComponent?.id || !selectedComponent?.componentStyles) return;
    const nextBorder = `${borderStyle} ${Number(borderWidth)}px ${toRgbaCss(rgb)}`;
    if (nextBorder.includes("undefined")) return;

    setBorderColor(rgb);
    latestBorderColorRef.current = rgb;
    patchSelectedLayerStyles({ border: nextBorder });
  };

  const applyScrollTrackColor = (rgb) => {
    if (!selectedComponent?.id || !selectedComponent?.componentStyles) return;
    const nextTrackColor = toRgbaCss(rgb);
    if (!nextTrackColor || nextTrackColor.includes("undefined")) return;

    setScrollColor(rgb);
    latestScrollColorRef.current = rgb;
    trackPickerOpenRef.current = true;
    patchSelectedLayerStyles({ thumbColor: nextTrackColor });
  };

  const applyScrollThumbColor = (rgb) => {
    if (!selectedComponent?.id || !selectedComponent?.componentStyles) return;
    const nextThumbColor = toRgbaCss(rgb);
    if (!nextThumbColor || nextThumbColor.includes("undefined")) return;

    setScrollThumbColor(rgb);
    latestScrollThumbColorRef.current = rgb;
    scrollThumbPickerOpenRef.current = true;
    patchSelectedLayerStyles({ scrollThumbColor: nextThumbColor });
  };

  const applyScrollThumbBgColor = (rgb) => {
    if (!selectedComponent?.id || !selectedComponent?.componentStyles) return;
    const nextTrackBg = toRgbaCss(rgb);
    if (!nextTrackBg || nextTrackBg.includes("undefined")) return;

    setScrollThumbBgColor(rgb);
    latestScrollThumbBgColorRef.current = rgb;
    scrollThumbBgPickerOpenRef.current = true;
    patchSelectedLayerStyles({ scrollThumbBgColor: nextTrackBg });
  };

  const revertButtonFillColor = () => {
    const snapshot = fillColorSnapshotRef.current;
    if (!snapshot) return;
    if (snapshot.rgb) {
      setButtonColor(snapshot.rgb);
      latestButtonFillRef.current = snapshot.rgb;
    }
    applyButtonFillColor(snapshot.css || snapshot.rgb, { updateSwatch: false });
    applyShapeFillColor(snapshot.rgb || snapshot.css);
  };

  const revertButtonBorderColor = () => {
    const snapshot = borderColorSnapshotRef.current;
    if (!snapshot) return;
    if (snapshot.rgb) {
      setBorderColor(snapshot.rgb);
      latestBorderColorRef.current = snapshot.rgb;
    }
    if (snapshot.css) {
      patchSelectedLayerStyles({ border: snapshot.css });
    }
    applyShapeStrokeColor(snapshot.rgb || snapshot.css);
  };

  const revertScrollTrackColor = () => {
    const snapshot = trackColorSnapshotRef.current;
    if (!snapshot) return;
    if (snapshot.rgb) {
      setScrollColor(snapshot.rgb);
      latestScrollColorRef.current = snapshot.rgb;
    }
    if (snapshot.css || snapshot.rgb) {
      applyScrollTrackColor(snapshot.rgb || snapshot.css);
    }
  };

  const revertScrollThumbColor = () => {
    const snapshot = scrollThumbColorSnapshotRef.current;
    if (!snapshot) return;
    if (snapshot.rgb) {
      setScrollThumbColor(snapshot.rgb);
      latestScrollThumbColorRef.current = snapshot.rgb;
    }
    if (snapshot.rgb || snapshot.css) {
      applyScrollThumbColor(snapshot.rgb || snapshot.css);
    }
  };

  const revertScrollThumbBgColor = () => {
    const snapshot = scrollThumbBgColorSnapshotRef.current;
    if (!snapshot) return;
    if (snapshot.rgb) {
      setScrollThumbBgColor(snapshot.rgb);
      latestScrollThumbBgColorRef.current = snapshot.rgb;
    }
    if (snapshot.rgb || snapshot.css) {
      applyScrollThumbBgColor(snapshot.rgb || snapshot.css);
    }
  };

  useEffect(() => {
    latestButtonFillRef.current = buttonColor;
  }, [buttonColor]);

  useEffect(() => {
    latestBorderColorRef.current = borderColor;
  }, [borderColor]);

  useEffect(() => {
    latestScrollColorRef.current = scrollColor;
  }, [scrollColor]);

  useEffect(() => {
    latestScrollThumbColorRef.current = scrollThumbColor;
  }, [scrollThumbColor]);

  useEffect(() => {
    latestScrollThumbBgColorRef.current = scrollThumbBgColor;
  }, [scrollThumbBgColor]);

  // Close (X or outside-click) commits the live color to RHS + canvas.
  useEffect(() => {
    fillPickerOpenRef.current = !!displayColorPicker;
    if (displayColorPicker) {
      fillPickerWasOpenRef.current = true;
      return;
    }
    if (!fillPickerWasOpenRef.current) return;
    fillPickerWasOpenRef.current = false;
    if (fillPickerDismissRef.current === "cancel") {
      fillPickerDismissRef.current = null;
      requestAnimationFrame(() => {
        if (typeof setCanvasStyleDraft === "function") {
          setCanvasStyleDraft(null);
        }
      });
      return;
    }
    fillPickerDismissRef.current = null;
    applyButtonFillColor(latestButtonFillRef.current);
    applyShapeFillColor(latestButtonFillRef.current);
    requestAnimationFrame(() => {
      if (typeof setCanvasStyleDraft === "function") {
        setCanvasStyleDraft(null);
      }
    });
  }, [displayColorPicker]);

  useEffect(() => {
    borderPickerOpenRef.current = !!displayColorPickerBorder;
    if (displayColorPickerBorder) {
      borderPickerWasOpenRef.current = true;
      return;
    }
    if (!borderPickerWasOpenRef.current) return;
    borderPickerWasOpenRef.current = false;
    if (borderPickerDismissRef.current === "cancel") {
      borderPickerDismissRef.current = null;
      requestAnimationFrame(() => {
        if (typeof setCanvasStyleDraft === "function") {
          setCanvasStyleDraft(null);
        }
      });
      return;
    }
    borderPickerDismissRef.current = null;
    applyButtonBorderColor(latestBorderColorRef.current);
    applyShapeStrokeColor(latestBorderColorRef.current);
    requestAnimationFrame(() => {
      if (typeof setCanvasStyleDraft === "function") {
        setCanvasStyleDraft(null);
      }
    });
  }, [displayColorPickerBorder]);

  useEffect(() => {
    trackPickerOpenRef.current = !!displayColorPickerScrollColor;
    if (displayColorPickerScrollColor) {
      trackPickerWasOpenRef.current = true;
      return;
    }
    if (!trackPickerWasOpenRef.current) return;
    trackPickerWasOpenRef.current = false;
    if (trackPickerDismissRef.current === "cancel") {
      trackPickerDismissRef.current = null;
      return;
    }
    trackPickerDismissRef.current = null;
    applyScrollTrackColor(latestScrollColorRef.current);
  }, [displayColorPickerScrollColor]);

  useEffect(() => {
    scrollThumbPickerOpenRef.current = !!scrollThumbColorPicker;
    if (scrollThumbColorPicker) {
      scrollThumbPickerWasOpenRef.current = true;
      return;
    }
    if (!scrollThumbPickerWasOpenRef.current) return;
    scrollThumbPickerWasOpenRef.current = false;
    if (scrollThumbPickerDismissRef.current === "cancel") {
      scrollThumbPickerDismissRef.current = null;
      return;
    }
    scrollThumbPickerDismissRef.current = null;
    applyScrollThumbColor(latestScrollThumbColorRef.current);
  }, [scrollThumbColorPicker]);

  useEffect(() => {
    scrollThumbBgPickerOpenRef.current = !!scrollThumbBgColorPicker;
    if (scrollThumbBgColorPicker) {
      scrollThumbBgPickerWasOpenRef.current = true;
      return;
    }
    if (!scrollThumbBgPickerWasOpenRef.current) return;
    scrollThumbBgPickerWasOpenRef.current = false;
    if (scrollThumbBgPickerDismissRef.current === "cancel") {
      scrollThumbBgPickerDismissRef.current = null;
      return;
    }
    scrollThumbBgPickerDismissRef.current = null;
    applyScrollThumbBgColor(latestScrollThumbBgColorRef.current);
  }, [scrollThumbBgColorPicker]);

  // X / close: commit the current draft to RHS + canvas, then close.
  // Matches outside-click behavior so palette close is consistent everywhere.
  const hideColorPicker = () => {
    if (scrollThumbColorPicker || scrollThumbPickerOpenRef.current) {
      scrollThumbPickerDismissRef.current = null;
      applyScrollThumbColor(latestScrollThumbColorRef.current);
      setScrollThumbColorPicker(false);
    } else if (scrollThumbBgColorPicker || scrollThumbBgPickerOpenRef.current) {
      scrollThumbBgPickerDismissRef.current = null;
      applyScrollThumbBgColor(latestScrollThumbBgColorRef.current);
      setScrollThumbBgColorPicker(false);
    } else if (displayColorPickerFontColor) {
      if (selectedComponent?.componentStyles?.color) {
        patchSelectedLayerStyles({
          color: selectedComponent.componentStyles.color,
        });
      }
      setDisplayColorPickerFontColor(false);
    } else if (displayColorPicker || fillPickerOpenRef.current) {
      fillPickerDismissRef.current = null;
      applyButtonFillColor(latestButtonFillRef.current);
      setDisplayColorPicker(false);
    } else if (displayColorPickerBorder || borderPickerOpenRef.current) {
      borderPickerDismissRef.current = null;
      applyButtonBorderColor(latestBorderColorRef.current);
      setDisplayColorPickerBorder(false);
    } else if (displayColorPickerScrollColor || trackPickerOpenRef.current) {
      trackPickerDismissRef.current = null;
      applyScrollTrackColor(latestScrollColorRef.current);
      setDisplayColorPickerScrollColor(false);
    } else if (displayColorPickerBgColor) {
      if (canvasBgChange) {
        setCanvasUpdated(true);
        setCanvasDimension({
          ...canvasDimension,
          backgroundColor: myCanvasRef.current,
          canvasChanged: true,
        });
        appData.updateGenericInfo({
          ...appData?.genericInfo,
          rightUpdaed: true,
        });
      }
      setDisplayColorPickerBgColor(false);
    } else if (displaycolorpickerTextBg) {
      if (selectedComponent?.componentStyles?.textBgColor) {
        patchSelectedLayerStyles({
          textBgColor: selectedComponent.componentStyles.textBgColor,
        });
      }
      setDisplaycolorpickerTextBg(false);
    } else if (colorPickerFontColorISI) {
      if (selectedComponent?.componentStyles?.expandClose) {
        patchSelectedLayerStyles({
          expandClose: {
            ...selectedComponent.componentStyles.expandClose,
            fontColorISI:
              selectedComponent.componentStyles.expandClose.fontColorISI,
          },
        });
      }
      setColorPickerFontColorISI(false);
    } else if (colorPickerTextBgColorISI) {
      if (selectedComponent?.componentStyles?.expandClose) {
        patchSelectedLayerStyles({
          expandClose: {
            ...selectedComponent.componentStyles.expandClose,
            textBgColorISI:
              selectedComponent.componentStyles.expandClose.textBgColorISI,
          },
        });
      }
      setColorPickerTextBgColorISI(false);
    }
  };

  const replaceFontColor = (fontColor, origin) => {
    let fontColorN =
      origin != "fromOnComplete"
        ? `rgba(${fontColor?.r}, ${fontColor?.g}, ${fontColor?.b}, ${fontColor?.a})`
        : fontColor;
    if (selectedComponent) {
      let tempSelected = { ...selectedComponent };
      tempSelected.componentStyles.color = fontColorN;

      setSelectedComponent(tempSelected);

      let tempLayercompData = [...layerCompData];
      tempLayercompData.forEach((entry, index) => {
        if (entry.id === tempSelected.id) {
          tempLayercompData[index].componentStyles.color = fontColorN;
        }
      });
      if (origin === "fromOnComplete") return tempSelected;
    } else {
    }
  };
  const AntSwitch = withStyles((theme) => ({
    root: {
      width: 28,
      height: 16,
      padding: 0,
      display: "flex",
      marginLeft: "4px",
    },
    switchBase: {
      padding: 2,
      color: theme.palette.grey[500],
      "&$checked": {
        transform: "translateX(12px)",
        color: theme.palette.common.white,
        "& + $track": {
          opacity: 1,
          backgroundColor: "#203662",
          borderColor: "#203662",
        },
      },
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: "none",
      background: currentAspectRatioLocked ? "white" : "",
    },
    track: {
      border: `1px solid ${theme.palette.grey[500]}`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: theme.palette.common.white,
    },
    checked: {},
  }))(Switch);
  const ToggleAspectLock = () => {
    if (
      !selectedComponent ||
      !selectedComponent?.id ||
      selectedComponent?.componentType === "default"
    ) {
      return;
    }
    const nextAspectRatioLock = !currentAspectRatioLocked;
    const updatedSelectedComponent = {
      ...selectedComponent,
      componentStyles: {
        ...selectedComponent.componentStyles,
        aspectLock: nextAspectRatioLock,
      },
    };
    setSelectedComponent(updatedSelectedComponent);
    setLayerCompData((prevLayerCompData) =>
      prevLayerCompData.map((component) => ({
        ...component,
        componentStyles: {
          ...component.componentStyles,
          aspectLock: nextAspectRatioLock,
        },
        ...(component?.scrollbarComponents
          ? {
              scrollbarComponents: component.scrollbarComponents.map(
                (scrollItem) => ({
                  ...scrollItem,
                  componentStyles: {
                    ...scrollItem.componentStyles,
                    aspectLock: nextAspectRatioLock,
                  },
                }),
              ),
            }
          : {}),
      })),
    );
    setIsAspectRatioLocked(nextAspectRatioLock);
  };
  const collectColorOnChangeComplete = (e) => {
    if (displayColorPickerBgColor && canvasBgChange) {
      setCanvasUpdated(true);
      setCanvasDimension({
        ...canvasDimension,
        backgroundColor: myCanvasRef.current,
        canvasChanged: true,
      });
      appData.updateGenericInfo({ ...appData?.genericInfo, rightUpdaed: true });
      return;
    }
    let tempLyaer = [...layerCompData];
    if (displayColorPickerFontColor) {
      let tempSelected = replaceFontColor(
        selectedComponent.componentStyles.color,
        "fromOnComplete",
      );
      tempLyaer[
        tempLyaer.findIndex((comp) => comp.id === tempSelected.id)
      ].componentStyles.color = tempSelected?.componentStyles?.color;
    }
    if (displaycolorpickerTextBg) {
      let tempSelected = { ...selectedComponent };
      tempLyaer[
        tempLyaer.findIndex((comp) => comp.id === tempSelected.id)
      ].componentStyles.textBgColor =
        tempSelected?.componentStyles?.textBgColor;
    }
    // Fill/border/track colors are applied live on every onChange. Do not
    // rewrite them here from selectedComponent — that closure is often stale
    // and snaps the canvas back to the old color.
    if (displayColorPicker && selectedComponent?.id) {
      applyButtonFillColor(latestButtonFillRef.current);
      return;
    }
    if (displayColorPickerBorder && selectedComponent?.id) {
      applyButtonBorderColor(latestBorderColorRef.current);
      return;
    }
    if (displayColorPickerScrollColor && selectedComponent?.id) {
      applyScrollTrackColor(latestScrollColorRef.current);
      return;
    }
    if (scrollThumbColorPicker && selectedComponent?.id) {
      applyScrollThumbColor(latestScrollThumbColorRef.current);
      return;
    }
    if (scrollThumbBgColorPicker && selectedComponent?.id) {
      applyScrollThumbBgColor(latestScrollThumbBgColorRef.current);
      return;
    }
    if (tempLyaer[tempLyaer.length - 1]?.eachDrag)
      tempLyaer[tempLyaer.length - 1].eachDrag = "no";
    setLayerCompData(tempLyaer);
  };

  const handleTextColorChange = (e) => {
    if (scrollThumbColorPicker) {
      applyScrollThumbColor(e.rgb);
    } else if (scrollThumbBgColorPicker) {
      applyScrollThumbBgColor(e.rgb);
    } else if (displayColorPickerFontColor) {
      let fontColor = e.rgb;
      replaceFontColor(fontColor);
      setTextColor(fontColor);
    } else if (displayColorPicker) {
      const nextRgb = e.rgb;
      if (selectedComponent?.componentStyles) {
        // Live preview while palette is open.
        applyButtonFillColor(nextRgb);
        applyShapeFillColor(nextRgb);
      } else {
        setButtonColor({ r: "241", g: "112", b: "19" });
      }
    } else if (displayColorPickerBorder) {
      const nextBorderRgb = e.rgb;
      if (selectedComponent?.componentStyles) {
        // Live border preview on canvas.
        applyButtonBorderColor(nextBorderRgb);
        applyShapeStrokeColor(nextBorderRgb);
      } else {
        setBorderColor({ r: "241", g: "112", b: "19" });
      }
    } else if (displayColorPickerScrollColor) {
      if (selectedComponent?.componentStyles) {
        applyScrollTrackColor(e.rgb);
      } else {
        setScrollColor({ r: "241", g: "112", b: "19" });
      }
    } else if (displayColorPickerBgColor) {
      //2776 canvasUndo
      if (canvasBgChange) setCanvasUpdated(false);

      let bgColor = e.rgb;
      appData.updateGenericInfo({ ...appData?.genericInfo, rightUpdaed: true });
      myCanvasRef.current = bgColor;
      setCanvasDimension({
        ...canvasDimension,
        backgroundColor: bgColor,
        canvasChanged: false,
      });
    } else if (displaycolorpickerTextBg) {
      let textBackgroundColor = e.rgb;
      if (e.rgb.a === 0) setundoFlag(true);
      if (selectedComponent?.componentStyles?.textBgColor) {
        let tempSlected = { ...selectedComponent };
        tempSlected.componentStyles.textBgColor = `rgba(${textBackgroundColor?.r},${textBackgroundColor?.g},${textBackgroundColor?.b},${textBackgroundColor?.a})`;
        setSelectedComponent(tempSlected);
        setTextBgColor(textBackgroundColor);
      } else {
        setTextBgColor({ r: "241", g: "112", b: "19" });
      }
    } else if (colorPickerTextBgColorISI) {
      let textBackgroundColorISI = e.rgb;

      if (e.rgb.a === 0) setundoFlag(true);
      if (selectedComponent?.componentStyles?.expandClose?.textBgColorISI) {
        let tempSlected = { ...selectedComponent };
        tempSlected.componentStyles.expandClose.textBgColorISI = `rgba(${textBackgroundColorISI?.r},${textBackgroundColorISI?.g},${textBackgroundColorISI?.b},${textBackgroundColorISI?.a})`;
        setSelectedComponent(tempSlected);
        setTextBgColorISI(textBackgroundColorISI);
      } else {
        setTextBgColorISI({ r: "241", g: "112", b: "19" });
      }
    } else if (colorPickerFontColorISI) {
      let fontColISI = e.rgb;

      if (e.rgb.a === 0) setundoFlag(true);
      if (selectedComponent?.componentStyles?.expandClose?.fontColorISI) {
        let tempSlected = { ...selectedComponent };
        tempSlected.componentStyles.expandClose.fontColorISI = `rgba(${fontColISI?.r},${fontColISI?.g},${fontColISI?.b},${fontColISI?.a})`;
        setSelectedComponent(tempSlected);
        setFontColorISI(fontColISI);
      } else {
        setFontColorISI({ r: "241", g: "112", b: "19" });
      }
    }

    if (layerCompData[layerCompData.length - 1]) {
      layerCompData[layerCompData.length - 1].eachDrag = "yes";
    }
  };
  const handleBgColorChange = (e) => {
    let bgColor = e.rgb;
    setCanvasDimension({
      ...canvasDimension,
      backgroundColor: bgColor,
      canvasChanged: false,
    });
    appData.updateGenericInfo({ ...appData?.genericInfo, rightUpdaed: true });
  };

  const handleURL = (e) => {
    setURLValue(e.target.value);
  };
  const URLUpdate = () => {
    if (isValidHttpUrl(URLValue)) {
      if (selectedComponent?.componentType === "Image") {
        let updatedValue = { ...selectedComponent };
        updatedValue.componentStyles.background = URLValue;
        setSelectedComponent(updatedValue);
      } else if (layerId.type === "Image") {
        if (URLValue !== "" && checkURL(URLValue))
          imageOnCanvas(
            undefined,
            URLValue,
            20,
            30,
            URLValue.substr(URLValue.lastIndexOf("/") + 1),
          );
      }
    }
  };

  function browseAndSelect(e) {
    let files = e.target.files;
    let fileName = files[0]?.name.replace(/[\(\)']+/g, "").replace(/\s/g, "");

    if (files[0].type !== "image/png" && files[0].type !== "image/jpeg") {
      return;
    }

    const myRenamedFile = new File([files[0]], fileName);

    let reader = new FileReader();
    reader.readAsDataURL(myRenamedFile);

    reader.onload = (e) => {
      const formData = new FormData();
      formData.append("fileName", myRenamedFile);

      browseImages(formData, (response, err, errorCode) => {
        if (err) {
          const errCoponent = ErrComponentToRender(errorCode);
          toast.error(<div className="notificationText">{errorCode}</div>);
        } else {
          imageOnCanvas(undefined, response.data.discription, 20, 30, fileName);
        }
      });
    };
  }

  function handleImage(e) {
    if (selectedComponent?.componentType === "Image") {
      let valueImage = { ...selectedComponent };
      selectedComponent.componentStyles[e.target.name] =
        e.target.checked === true ? "" : "no-repeat";
      valueImage.componentStyles.repeat = e.target.checked;
      setSelectedComponent(valueImage);
      setCheckBoxRepeat(e.target.checked);
    }
  }

  const Delete = () => {
    if (selectedComponent.id) {
      let tempElemLayers = [...layerCompData];
      let filetredLayers = tempElemLayers.filter(
        (layer) => layer.id !== selectedComponent.id,
      );
      setLayerCompData(filetredLayers);
      setSelectedComponent({});
    }
  };

  const showComponentType = !hideFlag
    ? selectedComponent?.componentType === "Text"
      ? t("TRANSFORM")
      : selectedComponent?.componentType === "Button"
        ? t("editorRightPanel.propertiesTabcontent.buttonSetting")
        : selectedComponent?.componentType === "Image"
          ? t("editorRightPanel.propertiesTabcontent.imageSetting")
          : selectedComponent?.componentType === "Shape"
            ? t("editorRightPanel.propertiesTabcontent.shapeSetting")
            : selectedComponent?.componentType === "Image" ||
                layerId.type === "Image"
              ? "IMAGE SETTING"
              : t("BANNER SIZE")
    : t("BANNER SIZE");

  const handleBannerSize = (e) => {
    setCanvasUpdated(true);
    let bannerSize = e.target.value;
    const match = bannerSize.match(/\d{2,4}x\d{2,4}/);
    let bannerWidthAandHeight = match[0].split("x");
    setCanvasDimension({
      ...canvasDimension,
      width: parseInt(bannerWidthAandHeight[0]),
      height: parseInt(bannerWidthAandHeight[1]),
    });

    appData.updateGenericInfo({ ...appData?.genericInfo, rightUpdaed: true });
  };

  /**
   * Shape SVGs carry their own fill/stroke, so the colour has to be written into
   * the data URI. Values arrive straight from the live picker because component
   * state is still one render behind while the palette is being dragged.
   */
  const applyShapeSvgAttribute = (attribute, value) => {
    const svgKey = getShapeSvgSourceKey(
      selectedComponent?.textComponentType?.addContent,
    );
    const shapeId = selectedComponent?.id;
    if (!svgKey || !shapeId || !value) return;

    const withAttribute = (comp) => {
      const nextSrc = setSvgAttributeInSrc(comp[svgKey], attribute, value);
      return nextSrc === comp[svgKey] ? comp : { ...comp, [svgKey]: nextSrc };
    };

    setSelectedComponent((prev) =>
      prev?.id === shapeId ? withAttribute(prev) : prev,
    );
    setLayerCompData((prevData) =>
      prevData.map((comp) =>
        String(comp.id) === String(shapeId) ? withAttribute(comp) : comp,
      ),
    );
  };

  const applyShapeFillColor = (color) =>
    applyShapeSvgAttribute("fill", toSvgHexColor(color));

  const applyShapeStrokeColor = (color) =>
    applyShapeSvgAttribute("stroke", toSvgHexColor(color));

  const applyShapeStrokeWidth = (width) => {
    const numericWidth = Number(width);
    if (!Number.isFinite(numericWidth) || numericWidth < 0) return;
    applyShapeSvgAttribute("stroke-width", String(numericWidth));
  };
  const ENUM_STATES = {
    Text: (
      <div>
        <Transform
          isAspectRatioLocked={currentAspectRatioLocked}
          setIsAspectRatioLocked={setIsAspectRatioLocked}
          showComponentType={showComponentType}
          styles={styles}
          bgColorCanvas={bgColorCanvas}
          handleDimensions={handleDimensions}
          handleBannerSize={handleBannerSize}
          canvasDimension={canvasDimension}
          bannerSizes={bannerSizes}
          handleClickSwatchBgColor={handleClickSwatchBgColor}
          handleBgColorChange={handleBgColorChange}
          refBgColor={refBgColor}
          displayColorPickerBgColor={displayColorPickerBgColor}
          updatedValue={updatedValue}
          dimensionsData={dimensionsData}
          checkedAspect={checkedAspect}
          ToggleAspectLock={ToggleAspectLock}
          selectedComponent={selectedComponent}
          setSelectedComponent={setSelectedComponent}
          handleBlur={handleBlur}
          layerCompData={layerCompData}
          setUpdatedValue={setUpdatedValue}
          toggleAnimatedBanner={toggleAnimatedBanner}
        ></Transform>
        <TextAndButton
          isCustomScroll={isCustomScroll}
          selectedFontId={selectedFontId}
          setSelectedFontId={setSelectedFontId}
          updateSelctedFontstyle={updateSelctedFontstyle}
          createFroalaInstance={createFroalaInstance}
          froalaIndex={froalaIndex}
          fontStylesonClick={fontStylesonClick}
          fontAlignmentonClick={fontAlignmentonClick}
          listOnclick={listOnclick}
          setLayerCompData={setLayerCompData}
          handleTextPropsOnchange={handleTextPropsOnchange}
          localRightProps={localRightProps}
          setLocalRightProps={setLocalRightProps}
          selectedComponent={selectedComponent}
          setSelectedComponent={setSelectedComponent}
          handleChange={handleChange}
          expanded={expanded}
          textColor={textColor}
          styles={styles}
          handleTextColorChange={handleTextColorChange}
          ColorPicker={ColorPicker}
          handleFontFamily={handleFontFamily}
          refFontColorISI={refFontColorISI}
          colorPickerFontColorISI={colorPickerFontColorISI}
          colorPickerTextBgColorISI={colorPickerTextBgColorISI}
          refTextBgColorISI={refTextBgColorISI}
          handleClickFontColorISI={handleClickFontColorISI}
          handleClicktextBgColorISI={handleClicktextBgColorISI}
          refFontColor={refFontColor}
          displayColorPickerFontColor={displayColorPickerFontColor}
          fontFamily={fontFamily}
          fontFamilyItems={fontFamilyItems}
          getFontOptionCssStack={getFontOptionCssStack}
          fontSize={fontSize}
          fontSizeItems={fontSizeItems}
          fontWeight={fontWeight}
          fontWeightItems={fontWeightItems}
          AV={AV}
          characterSpacing={characterSpacing}
          letterSpacingItems={letterSpacingItems}
          LineHeight={LineHeight}
          handleClickSwatchFontCOlor={handleClickSwatchFontCOlor}
          lineHeightProp={lineHeightProp}
          lineHeightItems={lineHeightItems}
          froalaFontAlignments={froalaFontAlignments}
          froalaNumberList={froalaNumberList}
          froalaFontStyles={froalaFontStyles}
          setDisplayColorPickerFontColor={setDisplayColorPickerFontColor}
          layerCompData={layerCompData}
          toggleScrollbar={toggleScrollbar}
          handleTextBgColor={handleTextBgColor}
          refTextBg={refTextBg}
          displaycolorpickerTextBg={displaycolorpickerTextBg}
          setFontSize={setFontSize}
          setLineHeightProp={setLineHeightProp}
          setCharacterSpacing={setCharacterSpacing}
          // selectedId={selectedId}
          // setSelectedId={setSelectedId}
        />
        {selectedComponent.componentStyles?.toggleScroll && (
          <ScrollBarArrow
            layerCompData={layerCompData}
            setLayerCompData={setLayerCompData}
            handleChange={handleChange}
            expanded={expanded}
            refScrollColor={refScrollColor}
            displayColorPickerScrollColor={displayColorPickerScrollColor}
            setDisplayColorPickerScrollColor={setDisplayColorPickerScrollColor}
            ColorPicker={ColorPicker}
            styles={styles}
            handleClickSwatchScroll={handleClickSwatchScroll}
            scrollColor={scrollColor}
            scrollbarArrow={scrollbarArrow}
            setScrollbarArrow={setScrollbarArrow}
            setScrollDimensionData={setScrollDimensionData}
            scrollDimensionData={scrollDimensionData}
            selectedComponent={selectedComponent}
            setSelectedComponent={setSelectedComponent}
            refFontColorISI={refFontColorISI}
            colorPickerFontColorISI={colorPickerFontColorISI}
            colorPickerTextBgColorISI={colorPickerTextBgColorISI}
            refTextBgColorISI={refTextBgColorISI}
            handleClickFontColorISI={handleClickFontColorISI}
            handleClicktextBgColorISI={handleClicktextBgColorISI}
            locked={locked}
            scrollBarExpand={scrollBarExpand}
            froalaIndex={froalaIndex}
          />
        )}
      </div>
    ),
    Button: (
      <>
        <Transform
          isAspectRatioLocked={currentAspectRatioLocked}
          setIsAspectRatioLocked={setIsAspectRatioLocked}
          showComponentType={showComponentType}
          styles={styles}
          bgColorCanvas={bgColorCanvas}
          handleDimensions={handleDimensions}
          handleBannerSize={handleBannerSize}
          canvasDimension={canvasDimension}
          bannerSizes={bannerSizes}
          handleClickSwatchBgColor={handleClickSwatchBgColor}
          handleBgColorChange={handleBgColorChange}
          refBgColor={refBgColor}
          displayColorPickerBgColor={displayColorPickerBgColor}
          updatedValue={updatedValue}
          dimensionsData={dimensionsData}
          checkedAspect={checkedAspect}
          ToggleAspectLock={ToggleAspectLock}
          selectedComponent={selectedComponent}
          setSelectedComponent={setSelectedComponent}
          layerCompData={layerCompData}
          setUpdatedValue={setUpdatedValue}
          toggleAnimatedBanner={toggleAnimatedBanner}
        ></Transform>
        <ButtonAndShape
          commonPadding={commonPadding}
          handleChange={handleChange}
          expanded={expanded}
          selectedComponent={selectedComponent}
          styles={styles}
          handleClickSwatch={handleClickSwatch}
          displayColorPicker={displayColorPicker}
          ColorPicker={ColorPicker}
          handleClose={handleClose}
          buttonColor={buttonColor}
          setDisplayColorPicker={setDisplayColorPicker}
          handleClickSwatchBorder={handleClickSwatchBorder}
          refBorder={refBorder}
          borderColor={borderColor}
          setDisplayColorPickerBorder={setDisplayColorPickerBorder}
          changeBorderStyle={changeBorderStyle}
          borderStyle={borderStyle}
          borderStyles={borderStyles}
          borderWidth={borderWidth}
          setBorderWidth={setBorderWidth}
          changeBorderWidth={changeBorderWidth}
          displayColorPickerBorder={displayColorPickerBorder}
          refButtonColor={refButtonColor}
          paddingTRBL={paddingTRBL}
          setPaddingTRBL={setPaddingTRBL}
          radiusTRBL={radiusTRBL}
          setRadiusTRBL={setRadiusTRBL}
          //  commonPadding={commonPadding}
          setCommonPadding={setCommonPadding}
          commonRadius={commonRadius}
          setCommonRadius={setCommonRadius}
          handlePadding={handlePadding}
          handleRadius={handleRadius}
          changeRadius={changeRadius}
          changePadding={changePadding}
          targetLink={targetLink}
          changeTargetLink={changeTargetLink}
          cornerCount={cornerCount}
          setCornerCount={setCornerCount}
          handleCornerCount={handleCornerCount}
          layerCompData={layerCompData}
        ></ButtonAndShape>
        <TextAndButton
          selectedFontId={selectedFontId}
          setSelectedFontId={setSelectedFontId}
          updateSelctedFontstyle={updateSelctedFontstyle}
          createFroalaInstance={createFroalaInstance}
          froalaIndex={froalaIndex}
          fontStylesonClick={fontStylesonClick}
          fontAlignmentonClick={fontAlignmentonClick}
          listOnclick={listOnclick}
          setLayerCompData={setLayerCompData}
          handleTextPropsOnchange={handleTextPropsOnchange}
          localRightProps={localRightProps}
          setLocalRightProps={setLocalRightProps}
          selectedComponent={selectedComponent}
          setSelectedComponent={setSelectedComponent}
          handleChange={handleChange}
          expanded={expanded}
          textColor={textColor}
          styles={styles}
          handleTextColorChange={handleTextColorChange}
          ColorPicker={ColorPicker}
          handleFontFamily={handleFontFamily}
          refFontColorISI={refFontColorISI}
          colorPickerFontColorISI={colorPickerFontColorISI}
          colorPickerTextBgColorISI={colorPickerTextBgColorISI}
          refTextBgColorISI={refTextBgColorISI}
          handleClickFontColorISI={handleClickFontColorISI}
          handleClicktextBgColorISI={handleClicktextBgColorISI}
          refFontColor={refFontColor}
          displayColorPickerFontColor={displayColorPickerFontColor}
          fontFamily={fontFamily}
          fontFamilyItems={fontFamilyItems}
          getFontOptionCssStack={getFontOptionCssStack}
          fontSize={fontSize}
          fontSizeItems={fontSizeItems}
          fontWeight={fontWeight}
          fontWeightItems={fontWeightItems}
          AV={AV}
          characterSpacing={characterSpacing}
          letterSpacingItems={letterSpacingItems}
          LineHeight={LineHeight}
          handleClickSwatchFontCOlor={handleClickSwatchFontCOlor}
          lineHeightProp={lineHeightProp}
          lineHeightItems={lineHeightItems}
          froalaFontAlignments={froalaFontAlignments}
          froalaNumberList={froalaNumberList}
          froalaFontStyles={froalaFontStyles}
          borderColor={borderColor}
          setDisplayColorPickerBorder={setDisplayColorPickerBorder}
          setDisplayColorPickerFontColor={setDisplayColorPickerFontColor}
          layerCompData={layerCompData}
          setCheckedScroll={setCheckedScroll}
          checkedScroll={checkedScroll}
          handleTextBgColor={handleTextBgColor}
          setFontSize={setFontSize}
          //  fontSizeConfig={fontSizeConfig}
          setLineHeightProp={setLineHeightProp}
          setCharacterSpacing={setCharacterSpacing}
        />
      </>
    ),
    Image: (
      <div>
        <Transform
          isAspectRatioLocked={currentAspectRatioLocked}
          setIsAspectRatioLocked={setIsAspectRatioLocked}
          showComponentType={showComponentType}
          styles={styles}
          bgColorCanvas={bgColorCanvas}
          handleDimensions={handleDimensions}
          handleBannerSize={handleBannerSize}
          canvasDimension={canvasDimension}
          bannerSizes={bannerSizes}
          handleClickSwatchBgColor={handleClickSwatchBgColor}
          handleBgColorChange={handleBgColorChange}
          refBgColor={refBgColor}
          displayColorPickerBgColor={displayColorPickerBgColor}
          updatedValue={updatedValue}
          dimensionsData={dimensionsData}
          checkedAspect={checkedAspect}
          ToggleAspectLock={ToggleAspectLock}
          selectedComponent={selectedComponent}
          setSelectedComponent={setSelectedComponent}
          handleBlur={handleBlur}
          layerCompData={layerCompData}
          setUpdatedValue={setUpdatedValue}
          toggleAnimatedBanner={toggleAnimatedBanner}
        ></Transform>
        <ImageBorder
          setSelectedComponent={setSelectedComponent}
          borderWidth={borderWidth}
          setBorderWidth={setBorderWidth}
          handleChange={handleChange}
          expanded={expanded}
          selectedComponent={selectedComponent}
          styles={styles}
          handleClickSwatch={handleClickSwatch}
          displayColorPicker={displayColorPicker}
          ColorPicker={ColorPicker}
          handleClose={handleClose}
          buttonColor={buttonColor}
          setDisplayColorPicker={setDisplayColorPicker}
          handleClickSwatchBorder={handleClickSwatchBorder}
          refBorder={refBorder}
          borderColor={borderColor}
          setDisplayColorPickerBorder={setDisplayColorPickerBorder}
          changeBorderStyle={changeBorderStyle}
          borderStyle={borderStyle}
          borderStyles={borderStyles}
          changeBorderWidth={changeBorderWidth}
          displayColorPickerBorder={displayColorPickerBorder}
          refButtonColor={refButtonColor}
          paddingTRBL={paddingTRBL}
          setPaddingTRBL={setPaddingTRBL}
          radiusTRBL={radiusTRBL}
          setRadiusTRBL={setRadiusTRBL}
          commonPadding={commonPadding}
          setCommonPadding={setCommonPadding}
          commonRadius={commonRadius}
          setCommonRadius={setCommonRadius}
          handlePadding={handlePadding}
          handleRadius={handleRadius}
          changeRadius={changeRadius}
          changePadding={changePadding}
          layerCompData={layerCompData}
        ></ImageBorder>
        <ImageComp
          handleChange={handleChange}
          expanded={expanded}
          layerId={layerId}
          selectedComponent={selectedComponent}
          Delete={Delete}
          ImageUpload={ImageUpload}
          handleImage={handleImage}
          URLValue={URLValue}
          handleURL={handleURL}
          browseAndSelect={browseAndSelect}
          targetLink={targetLink}
          changeTargetLink={changeTargetLink}
          checkBoxRepeat={checkBoxRepeat}
          URLUpdate={URLUpdate}
        />
      </div>
    ),
    Shape: (
      <>
        <Transform
          isAspectRatioLocked={currentAspectRatioLocked}
          setIsAspectRatioLocked={setIsAspectRatioLocked}
          showComponentType={showComponentType}
          styles={styles}
          bgColorCanvas={bgColorCanvas}
          handleDimensions={handleDimensions}
          handleBannerSize={handleBannerSize}
          canvasDimension={canvasDimension}
          bannerSizes={bannerSizes}
          handleClickSwatchBgColor={handleClickSwatchBgColor}
          handleBgColorChange={handleBgColorChange}
          refBgColor={refBgColor}
          displayColorPickerBgColor={displayColorPickerBgColor}
          updatedValue={updatedValue}
          dimensionsData={dimensionsData}
          ToggleAspectLock={ToggleAspectLock}
          checkedAspect={checkedAspect}
          selectedComponent={selectedComponent}
          setSelectedComponent={setSelectedComponent}
          handleBlur={handleBlur}
          layerCompData={layerCompData}
          setUpdatedValue={setUpdatedValue}
          toggleAnimatedBanner={toggleAnimatedBanner}
        ></Transform>
        <ButtonAndShape
          handleChange={handleChange}
          expanded={expanded}
          selectedComponent={selectedComponent}
          styles={styles}
          handleClickSwatch={handleClickSwatch}
          displayColorPicker={displayColorPicker}
          ColorPicker={ColorPicker}
          handleClose={handleClose}
          buttonColor={buttonColor}
          setDisplayColorPicker={setDisplayColorPicker}
          handleClickSwatchBorder={handleClickSwatchBorder}
          refBorder={refBorder}
          borderColor={borderColor}
          setDisplayColorPickerBorder={setDisplayColorPickerBorder}
          changeBorderStyle={changeBorderStyle}
          borderStyle={borderStyle}
          borderStyles={borderStyles}
          borderWidth={borderWidth}
          setBorderWidth={setBorderWidth}
          changeBorderWidth={changeBorderWidth}
          displayColorPickerBorder={displayColorPickerBorder}
          refButtonColor={refButtonColor}
          paddingTRBL={paddingTRBL}
          setPaddingTRBL={setPaddingTRBL}
          radiusTRBL={radiusTRBL}
          setRadiusTRBL={setRadiusTRBL}
          commonPadding={commonPadding}
          setCommonPadding={setCommonPadding}
          commonRadius={commonRadius}
          setCommonRadius={setCommonRadius}
          handlePadding={handlePadding}
          handleRadius={handleRadius}
          changeRadius={changeRadius}
          changePadding={changePadding}
          cornerCount={cornerCount}
          setCornerCount={setCornerCount}
          handleCornerCount={handleCornerCount}
          layerCompData={layerCompData}
        ></ButtonAndShape>
      </>
    ),
    Scrollbar: (
      <>
        <Transform
          isAspectRatioLocked={currentAspectRatioLocked}
          setIsAspectRatioLocked={setIsAspectRatioLocked}
          showComponentType={showComponentType}
          styles={styles}
          bgColorCanvas={bgColorCanvas}
          handleDimensions={handleDimensions}
          handleBannerSize={handleBannerSize}
          canvasDimension={canvasDimension}
          bannerSizes={bannerSizes}
          handleClickSwatchBgColor={handleClickSwatchBgColor}
          handleBgColorChange={handleBgColorChange}
          refBgColor={refBgColor}
          displayColorPickerBgColor={displayColorPickerBgColor}
          updatedValue={updatedValue}
          dimensionsData={dimensionsData}
          ToggleAspectLock={ToggleAspectLock}
          checkedAspect={checkedAspect}
          selectedComponent={selectedComponent}
          setSelectedComponent={setSelectedComponent}
          handleBlur={handleBlur}
          layerCompData={layerCompData}
          setUpdatedValue={setUpdatedValue}
          toggleAnimatedBanner={toggleAnimatedBanner}
        ></Transform>
        <ButtonAndShape
          borderRadius={borderRadius}
          handleChangeBorderRadius={handleChangeBorderRadius}
          handleClickSwatchScrollbar={handleClickSwatchScrollbar}
          handleClickSwatchScrollbarThumbBg={handleClickSwatchScrollbarThumbBg}
          handleChange={handleChange}
          expanded={expanded}
          selectedComponent={selectedComponent}
          styles={styles}
          handleClickSwatch={handleClickSwatch}
          displayColorPicker={displayColorPicker}
          ColorPicker={ColorPicker}
          handleClose={handleClose}
          buttonColor={buttonColor}
          setDisplayColorPicker={setDisplayColorPicker}
          handleClickSwatchBorder={handleClickSwatchBorder}
          refBorder={refBorder}
          borderColor={borderColor}
          setDisplayColorPickerBorder={setDisplayColorPickerBorder}
          changeBorderStyle={changeBorderStyle}
          borderStyle={borderStyle}
          borderStyles={borderStyles}
          borderWidth={borderWidth}
          setBorderWidth={setBorderWidth}
          changeBorderWidth={changeBorderWidth}
          displayColorPickerBorder={displayColorPickerBorder}
          refButtonColor={refButtonColor}
          paddingTRBL={paddingTRBL}
          setPaddingTRBL={setPaddingTRBL}
          radiusTRBL={radiusTRBL}
          setRadiusTRBL={setRadiusTRBL}
          commonPadding={commonPadding}
          setCommonPadding={setCommonPadding}
          commonRadius={commonRadius}
          setCommonRadius={setCommonRadius}
          handlePadding={handlePadding}
          handleRadius={handleRadius}
          changeRadius={changeRadius}
          changePadding={changePadding}
          cornerCount={cornerCount}
          setCornerCount={setCornerCount}
          handleCornerCount={handleCornerCount}
          layerCompData={layerCompData}
        ></ButtonAndShape>
      </>
    ),
    Reference: (
      <div>
        <Transform
          isAspectRatioLocked={currentAspectRatioLocked}
          setIsAspectRatioLocked={setIsAspectRatioLocked}
          showComponentType={showComponentType}
          styles={styles}
          bgColorCanvas={bgColorCanvas}
          handleDimensions={handleDimensions}
          handleBannerSize={handleBannerSize}
          canvasDimension={canvasDimension}
          bannerSizes={bannerSizes}
          handleClickSwatchBgColor={handleClickSwatchBgColor}
          handleBgColorChange={handleBgColorChange}
          refBgColor={refBgColor}
          displayColorPickerBgColor={displayColorPickerBgColor}
          updatedValue={updatedValue}
          dimensionsData={dimensionsData}
          checkedAspect={checkedAspect}
          ToggleAspectLock={ToggleAspectLock}
          selectedComponent={selectedComponent}
          setSelectedComponent={setSelectedComponent}
          handleBlur={handleBlur}
          layerCompData={layerCompData}
          setUpdatedValue={setUpdatedValue}
          toggleAnimatedBanner={toggleAnimatedBanner}
        ></Transform>
        <TextAndButton
          isCustomScroll={isCustomScroll}
          selectedFontId={selectedFontId}
          setSelectedFontId={setSelectedFontId}
          updateSelctedFontstyle={updateSelctedFontstyle}
          createFroalaInstance={createFroalaInstance}
          froalaIndex={froalaIndex}
          fontStylesonClick={fontStylesonClick}
          fontAlignmentonClick={fontAlignmentonClick}
          listOnclick={listOnclick}
          setLayerCompData={setLayerCompData}
          handleTextPropsOnchange={handleTextPropsOnchange}
          localRightProps={localRightProps}
          setLocalRightProps={setLocalRightProps}
          selectedComponent={selectedComponent}
          setSelectedComponent={setSelectedComponent}
          handleChange={handleChange}
          expanded={expanded}
          textColor={textColor}
          styles={styles}
          handleTextColorChange={handleTextColorChange}
          ColorPicker={ColorPicker}
          handleFontFamily={handleFontFamily}
          refFontColorISI={refFontColorISI}
          colorPickerFontColorISI={colorPickerFontColorISI}
          colorPickerTextBgColorISI={colorPickerTextBgColorISI}
          refTextBgColorISI={refTextBgColorISI}
          handleClickFontColorISI={handleClickFontColorISI}
          handleClicktextBgColorISI={handleClicktextBgColorISI}
          refFontColor={refFontColor}
          displayColorPickerFontColor={displayColorPickerFontColor}
          fontFamily={fontFamily}
          fontFamilyItems={fontFamilyItems}
          getFontOptionCssStack={getFontOptionCssStack}
          fontSize={fontSize}
          fontSizeItems={fontSizeItems}
          fontWeight={fontWeight}
          fontWeightItems={fontWeightItems}
          AV={AV}
          characterSpacing={characterSpacing}
          letterSpacingItems={letterSpacingItems}
          LineHeight={LineHeight}
          handleClickSwatchFontCOlor={handleClickSwatchFontCOlor}
          lineHeightProp={lineHeightProp}
          lineHeightItems={lineHeightItems}
          froalaFontAlignments={froalaFontAlignments}
          froalaNumberList={froalaNumberList}
          froalaFontStyles={froalaFontStyles}
          setDisplayColorPickerFontColor={setDisplayColorPickerFontColor}
          layerCompData={layerCompData}
          toggleScrollbar={toggleScrollbar}
          handleTextBgColor={handleTextBgColor}
          refTextBg={refTextBg}
          displaycolorpickerTextBg={displaycolorpickerTextBg}
          setFontSize={setFontSize}
          setLineHeightProp={setLineHeightProp}
          setCharacterSpacing={setCharacterSpacing}
          // selectedId={selectedId}
          // setSelectedId={setSelectedId}
        />
        {selectedComponent.componentStyles?.toggleScroll && (
          <ScrollBarArrow
            layerCompData={layerCompData}
            setLayerCompData={setLayerCompData}
            handleChange={handleChange}
            expanded={expanded}
            refScrollColor={refScrollColor}
            displayColorPickerScrollColor={displayColorPickerScrollColor}
            setDisplayColorPickerScrollColor={setDisplayColorPickerScrollColor}
            ColorPicker={ColorPicker}
            styles={styles}
            handleClickSwatchScroll={handleClickSwatchScroll}
            scrollColor={scrollColor}
            scrollbarArrow={scrollbarArrow}
            setScrollbarArrow={setScrollbarArrow}
            setScrollDimensionData={setScrollDimensionData}
            scrollDimensionData={scrollDimensionData}
            selectedComponent={selectedComponent}
            setSelectedComponent={setSelectedComponent}
            refFontColorISI={refFontColorISI}
            colorPickerFontColorISI={colorPickerFontColorISI}
            colorPickerTextBgColorISI={colorPickerTextBgColorISI}
            refTextBgColorISI={refTextBgColorISI}
            handleClickFontColorISI={handleClickFontColorISI}
            handleClicktextBgColorISI={handleClicktextBgColorISI}
            locked={locked}
            scrollBarExpand={scrollBarExpand}
            froalaIndex={froalaIndex}
          />
        )}
      </div>
    ),
    Footnotes: (
      <div>
        <Transform
          isAspectRatioLocked={currentAspectRatioLocked}
          setIsAspectRatioLocked={setIsAspectRatioLocked}
          showComponentType={showComponentType}
          styles={styles}
          bgColorCanvas={bgColorCanvas}
          handleDimensions={handleDimensions}
          handleBannerSize={handleBannerSize}
          canvasDimension={canvasDimension}
          bannerSizes={bannerSizes}
          handleClickSwatchBgColor={handleClickSwatchBgColor}
          handleBgColorChange={handleBgColorChange}
          refBgColor={refBgColor}
          displayColorPickerBgColor={displayColorPickerBgColor}
          updatedValue={updatedValue}
          dimensionsData={dimensionsData}
          checkedAspect={checkedAspect}
          ToggleAspectLock={ToggleAspectLock}
          selectedComponent={selectedComponent}
          setSelectedComponent={setSelectedComponent}
          handleBlur={handleBlur}
          layerCompData={layerCompData}
          setUpdatedValue={setUpdatedValue}
          toggleAnimatedBanner={toggleAnimatedBanner}
        ></Transform>
        <TextAndButton
          isCustomScroll={isCustomScroll}
          selectedFontId={selectedFontId}
          setSelectedFontId={setSelectedFontId}
          updateSelctedFontstyle={updateSelctedFontstyle}
          createFroalaInstance={createFroalaInstance}
          froalaIndex={froalaIndex}
          fontStylesonClick={fontStylesonClick}
          fontAlignmentonClick={fontAlignmentonClick}
          listOnclick={listOnclick}
          setLayerCompData={setLayerCompData}
          handleTextPropsOnchange={handleTextPropsOnchange}
          localRightProps={localRightProps}
          setLocalRightProps={setLocalRightProps}
          selectedComponent={selectedComponent}
          setSelectedComponent={setSelectedComponent}
          handleChange={handleChange}
          expanded={expanded}
          textColor={textColor}
          styles={styles}
          handleTextColorChange={handleTextColorChange}
          ColorPicker={ColorPicker}
          handleFontFamily={handleFontFamily}
          refFontColorISI={refFontColorISI}
          colorPickerFontColorISI={colorPickerFontColorISI}
          colorPickerTextBgColorISI={colorPickerTextBgColorISI}
          refTextBgColorISI={refTextBgColorISI}
          handleClickFontColorISI={handleClickFontColorISI}
          handleClicktextBgColorISI={handleClicktextBgColorISI}
          refFontColor={refFontColor}
          displayColorPickerFontColor={displayColorPickerFontColor}
          fontFamily={fontFamily}
          fontFamilyItems={fontFamilyItems}
          getFontOptionCssStack={getFontOptionCssStack}
          fontSize={fontSize}
          fontSizeItems={fontSizeItems}
          fontWeight={fontWeight}
          fontWeightItems={fontWeightItems}
          AV={AV}
          characterSpacing={characterSpacing}
          letterSpacingItems={letterSpacingItems}
          LineHeight={LineHeight}
          handleClickSwatchFontCOlor={handleClickSwatchFontCOlor}
          lineHeightProp={lineHeightProp}
          lineHeightItems={lineHeightItems}
          froalaFontAlignments={froalaFontAlignments}
          froalaNumberList={froalaNumberList}
          froalaFontStyles={froalaFontStyles}
          setDisplayColorPickerFontColor={setDisplayColorPickerFontColor}
          layerCompData={layerCompData}
          toggleScrollbar={toggleScrollbar}
          handleTextBgColor={handleTextBgColor}
          refTextBg={refTextBg}
          displaycolorpickerTextBg={displaycolorpickerTextBg}
          setFontSize={setFontSize}
          setLineHeightProp={setLineHeightProp}
          setCharacterSpacing={setCharacterSpacing}
          // selectedId={selectedId}
          // setSelectedId={setSelectedId}
        />
        {selectedComponent.componentStyles?.toggleScroll && (
          <ScrollBarArrow
            layerCompData={layerCompData}
            setLayerCompData={setLayerCompData}
            handleChange={handleChange}
            expanded={expanded}
            refScrollColor={refScrollColor}
            displayColorPickerScrollColor={displayColorPickerScrollColor}
            setDisplayColorPickerScrollColor={setDisplayColorPickerScrollColor}
            ColorPicker={ColorPicker}
            styles={styles}
            handleClickSwatchScroll={handleClickSwatchScroll}
            scrollColor={scrollColor}
            scrollbarArrow={scrollbarArrow}
            setScrollbarArrow={setScrollbarArrow}
            setScrollDimensionData={setScrollDimensionData}
            scrollDimensionData={scrollDimensionData}
            selectedComponent={selectedComponent}
            setSelectedComponent={setSelectedComponent}
            refFontColorISI={refFontColorISI}
            colorPickerFontColorISI={colorPickerFontColorISI}
            colorPickerTextBgColorISI={colorPickerTextBgColorISI}
            refTextBgColorISI={refTextBgColorISI}
            handleClickFontColorISI={handleClickFontColorISI}
            handleClicktextBgColorISI={handleClicktextBgColorISI}
            locked={locked}
            scrollBarExpand={scrollBarExpand}
            froalaIndex={froalaIndex}
          />
        )}
      </div>
    ),
    default: (
      <GlobalSetting
        multiSelectedComps={multiSelectedComps}
        isAspectRatioLocked={currentAspectRatioLocked}
        setIsAspectRatioLocked={setIsAspectRatioLocked}
        handleChange={handleChange}
        expanded={expanded}
        showAssettype={showAssettype}
        showBannertype={showBannertype}
        genericInfo={genericInfo}
        setGenericInfo={setGenericInfo}
        showComponentType={showComponentType}
        styles={styles}
        bgColorCanvas={canvasDimension?.backgroundColor}
        handleDimensions={handleDimensions}
        handleBannerSize={handleBannerSize}
        canvasDimension={canvasDimension}
        setCanvasDimension={setCanvasDimension}
        bannerSizes={bannerSizes}
        handleClickSwatchBgColor={handleClickSwatchBgColor}
        handleBgColorChange={handleBgColorChange}
        refBgColor={refBgColor}
        displayColorPickerBgColor={displayColorPickerBgColor}
        setDisplayColorPickerBgColor={setDisplayColorPickerBgColor}
        setCanvasUpdated={setCanvasUpdated}
        toggleAnimatedBanner={toggleAnimatedBanner}
        setOpenTimelinePopup={setOpenTimelinePopup}
        playPause={playPause}
        updatedValue={updatedValue}
        dimensionsData={dimensionsData}
        checkedAspect={checkedAspect}
        ToggleAspectLock={ToggleAspectLock}
        selectedComponent={selectedComponent}
        setSelectedComponent={setSelectedComponent}
        handleBlur={handleBlur}
        layerCompData={layerCompData}
        setUpdatedValue={setUpdatedValue}
      />
    ),
  };
  const colorPickerForComponents = scrollThumbColorPicker
    ? scrollThumbColor
    : scrollThumbBgColorPicker
      ? scrollThumbBgColor
      : displayColorPickerFontColor
        ? textColor
        : displayColorPicker
          ? buttonColor
          : displayColorPickerBorder
            ? borderColor
            : displayColorPickerScrollColor
              ? scrollColor
              : displayColorPickerBgColor
                ? typeof canvasDimension.backgroundColor === "object"
                  ? canvasDimension.backgroundColor
                  : rgbaStringToObject(canvasDimension.backgroundColor) ||
                    canvasDimension.backgroundColor
                : displaycolorpickerTextBg
                  ? textBgColor
                  : colorPickerFontColorISI
                    ? fontColorISI
                    : colorPickerTextBgColorISI
                      ? textBgColorISI
                      : "";
  const colorReferencesForComp = scrollThumbBgColorPicker
    ? refScrollThumbBgColor
    : scrollThumbColorPicker
      ? refScrollThumbColor
      : displayColorPickerFontColor
        ? refFontColor
        : displayColorPicker
          ? refButtonColor
          : displayColorPickerBorder
            ? refBorder
            : displayColorPickerScrollColor
              ? refScrollColor
              : displayColorPickerBgColor
                ? refBgColor
                : displaycolorpickerTextBg
                  ? refTextBg
                  : colorPickerTextBgColorISI
                    ? refTextBgColorISI
                    : colorPickerFontColorISI
                      ? refFontColorISI
                      : "";
  const activeTab = isInfoPanel === true ? 1 : 0;

  const showComponentTypeText = () => {
    if (showComponentType === "TEXT" || showComponentType === "BUTTON ") {
      return "TRANSFORM";
    } else {
      return showComponentType;
    }
  };
  return (
    <>
      <div
        className="rightPanelEditor"
        style={{ pointerEvents: !playPause.animationCompleted && "none" }}
        ref={rightPanelRef}
      >
        <div className="rightPanelEditorscreen">
          {!isInfoPanel && (
            <>
              <div className="propertyInfoPanel-2">
                {t("editorRightPanel.tabs.properties")}{" "}
              </div>
              <div className="properties-tabpane rhsScroll">
                {" "}
                {showComponentType === "BANNER SIZE" ? (
                  ""
                ) : (
                  <div className="d-flex">
                    <div className="textSetting d-flex">
                      {showComponentTypeText()}
                    </div>
                    <div className="aspectLock d-flex">
                      {t("editorRightPanel.propertiesTabcontent.aspectLock")}
                      <AntSwitch
                        checked={currentAspectRatioLocked}
                        onChange={(e) => {
                          ToggleAspectLock(e);
                        }}
                      />
                    </div>
                  </div>
                )}
                <div className="rhsScroll2">
                  {!hideFlag &&
                    layerCompData &&
                    ENUM_STATES[selectedComponent?.componentType]}
                  {!hideFlag &&
                  (selectedComponent?.componentType === "Text" ||
                    selectedComponent?.componentType === "Button" ||
                    selectedComponent?.componentType === "Image" ||
                    selectedComponent?.componentType === "Shape" ||
                    selectedComponent?.componentType === "Scrollbar" ||
                    selectedComponent?.componentType === "Reference" ||
                    selectedComponent?.componentType === "Footnotes") ? (
                    <div>
                      <div className="textTransform"></div>

                      {(selectedComponent?.componentType === "Button" ||
                        selectedComponent?.componentType === "Shape") && <></>}
                      {(selectedComponent?.componentType === "Text" ||
                        selectedComponent?.componentType === "Button") && <></>}
                      <>
                        {selectedComponent?.componentType !== "Shape" && (
                          <div>
                            <div className="accordion2 customAccordIcons1">
                              <Accordion
                                onChange={handleChange("panel4")}
                                expanded={expanded.panel4}
                              >
                                <AccordionSummary
                                  expandIcon={
                                    expanded.panel4 === true ? (
                                      <img
                                        src={DownwardArrow}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    ) : (
                                      <img
                                        src={SideArrow}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    )
                                  }
                                  aria-controls="panel4a-content"
                                  id="panel4a-header"
                                >
                                  <Typography className="accord2-summary">
                                    <div className="textProps">
                                      <div className="text">
                                        {t(
                                          "editorRightPanel.propertiesTabcontent.link",
                                        )}
                                      </div>
                                    </div>
                                  </Typography>
                                </AccordionSummary>

                                <AccordionDetails>
                                  <div>
                                    <TextField
                                      disabled={locked}
                                      className="custonScrollBar textFieldCustom3 linkButton"
                                      id="standard-basic"
                                      defaultValue="https://"
                                      value={targetLink}
                                      onChange={(e) => changeTargetLink(e)}
                                      onBlur={(e) =>
                                        changeTargetLink(e, "blur")
                                      }
                                      inputProps={{
                                        style: {
                                          width: "100%",
                                          marginTop: "-14px",
                                          marginBottom: "-15px",
                                          fontSize: "12px",
                                          color: "#000000",
                                          fontFamily: "Nunito Sans,sans-serif",
                                          fontStyle: "italic",
                                        },
                                      }}
                                    />
                                  </div>
                                </AccordionDetails>
                              </Accordion>
                            </div>
                            {selectedComponent?.componentType === "Image" && (
                              <div className="hitAreaSection accordion2 customAccordIcons1">
                                <Accordion
                                  onChange={handleChange("panel13")}
                                  expanded={expanded.panel13}
                                  TransitionProps={{ timeout: 150 }}
                                >
                                  <AccordionSummary
                                    expandIcon={
                                      expanded.panel13 === true ? (
                                        <img
                                          src={DownwardArrow}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      ) : (
                                        <img
                                          src={SideArrow}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      )
                                    }
                                    aria-controls="panel13a-content"
                                    id="panel13a-header"
                                  >
                                    <Typography className="accord2-summary">
                                      <div className="textProps hitAreaHeading">
                                        <div
                                          className="text"
                                          style={{ marginLeft: "14px" }}
                                        >
                                          {t(
                                            "editorRightPanel.propertiesTabcontent.hitArea",
                                          )}
                                        </div>
                                        <Tooltip
                                          title={t(
                                            "editorRightPanel.propertiesTabcontent.hitAreaPriorityMessage",
                                          )}
                                          placement="bottom"
                                          arrow
                                          open={hitAreaInfoOpen}
                                          disableFocusListener
                                          disableTouchListener
                                          disableHoverListener
                                          PopperProps={{
                                            onMouseEnter:
                                              openHitAreaInfoTooltip,
                                            onMouseLeave:
                                              scheduleCloseHitAreaInfoTooltip,
                                          }}
                                          classes={{
                                            popper: "hitAreaPriorityTooltip",
                                            tooltip: "hitAreaPriorityTooltip",
                                          }}
                                        >
                                          <span
                                            className="hitAreaInfoIcon"
                                            onMouseEnter={
                                              openHitAreaInfoTooltip
                                            }
                                            onMouseLeave={
                                              scheduleCloseHitAreaInfoTooltip
                                            }
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              clearHitAreaInfoCloseTimeout();
                                              setHitAreaInfoOpen(
                                                (prev) => !prev,
                                              );
                                            }}
                                          >
                                            <img
                                              src={InfoIcon}
                                              alt="info"
                                              className="img-fluid pl-1 hitAreaInfoIconImage"
                                            />
                                          </span>
                                        </Tooltip>
                                      </div>
                                    </Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <button
                                      type="button"
                                      className="hitAreaButton"
                                      disabled={locked}
                                      onClick={openHitAreaModal}
                                    >
                                      {shouldShowEditAndAddHitArea
                                        ? t(
                                            "editorRightPanel.propertiesTabcontent.editAndAddHitArea",
                                          )
                                        : t(
                                            "editorRightPanel.propertiesTabcontent.addHitArea",
                                          )}
                                    </button>
                                  </AccordionDetails>
                                </Accordion>
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    </div>
                  ) : (
                    (hideFlag ||
                      selectedComponent?.componentType !== "default") &&
                    ENUM_STATES["default"]
                  )}
                </div>
              </div>
            </>
          )}
          {isInfoPanel && (
            <>
              <div className="propertyInfoPanel">{t("DETAILS")} </div>
              <div className="info-tabpane">
                <InfotabSection
                  bannerId={bannerId}
                  setMLRstatus={setMLRstatus}
                  MLRstatus={MLRstatus}
                  damsID={damsID}
                  showAssettype={showAssettype}
                  showBannertype={showBannertype}
                  getEditSaveAssets={getEditSaveAssets}
                  setShowBannerName={setShowBannerName}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <div>
        {!locked &&
        (scrollThumbBgColorPicker ||
          scrollThumbColorPicker ||
          displayColorPickerFontColor ||
          displayColorPicker ||
          displayColorPickerBorder ||
          displayColorPickerScrollColor ||
          displayColorPickerBgColor ||
          displaycolorpickerTextBg ||
          colorPickerFontColorISI ||
          colorPickerTextBgColorISI) ? (
          <div ref={colorReferencesForComp}>
            <ColorPicker
              id="textColor"
              hideColorPicker={hideColorPicker}
              handleColorChange={handleTextColorChange}
              name="textColor"
              scrollThumbColorPicker={scrollThumbColorPicker}
              scrollThumbBgColorPicker={scrollThumbBgColorPicker}
              color={colorPickerForComponents || ""}
              displayColorPicker={displayColorPicker}
              displayColorPickerBgColor={displayColorPickerBgColor}
              displayColorPickerBorder={displayColorPickerBorder}
              displayColorPickerFontColor={displayColorPickerFontColor}
              displayColorPickerScrollColor={displayColorPickerScrollColor}
              displaycolorpickerTextBg={displaycolorpickerTextBg}
              colorPickerTextBgColorISI={colorPickerTextBgColorISI}
              colorPickerFontColorISI={colorPickerFontColorISI}
              collectColorOnChangeComplete={collectColorOnChangeComplete}
            />
          </div>
        ) : null}
      </div>
      <HitAreaModal
        open={isHitAreaModalOpen}
        onCancel={() => setIsHitAreaModalOpen(false)}
        onSave={saveHitAreaFromModal}
        selectedComponent={selectedComponent}
        showTimeline={!!toggleAnimatedBanner}
        timelineSeconds={seconds}
        totalDurationInSeconds={HIT_AREA_MODAL_TIMELINE_DURATION}
        totalDurationWidth={Math.round(
          ((appData?.genericInfo?.canvasScale?.width || 1359) /
            (appData?.genericInfo?.canvasScale?.divisions || 30)) *
            HIT_AREA_MODAL_TIMELINE_DURATION,
        )}
      />
    </>
  );
};
export default RightPanel;
